<template>
  <div>
    <b-modal
      ref="mdlTrocarUsuarioOuConta"
      @hidden="limpar"
      @shown="iniciarObservadorLista"
      ignore-enforce-focus-selector=".swal2-container"
      v-if="(checkSuperAdmin || isAccountAdmin) && contasParaTroca.length > 1"
      hide-footer
      size="xl"
      scrollable
      content-class="trocar-conta-modal-content"
      header-class="trocar-conta-modal-header border-0"
      body-class="trocar-conta-modal-body"
    >
      <template #modal-header="{ close }">
        <div class="trocar-conta-modal-header__conteudo">
          <div class="trocar-conta-modal-header__identidade">
            <h5 class="trocar-conta-modal-header__titulo">Central de Contas</h5>
            <span class="trocar-conta-modal-header__contador">
              {{ textoContadorCabecalho }}
            </span>
          </div>

          <!-- Botão de contexto do Super Admin centralizado entre título e ações -->
          <button
            v-if="checkSuperAdmin && hasAccount && superAdminTrigger"
            type="button"
            class="trocar-conta-btn-contexto"
            v-b-tooltip.noninteractive.hover
            title="Acessar o painel com visão completa da plataforma"
            @click="trocarParaSuperAdmin"
          >
            <span class="trocar-conta-btn-contexto__avatar">
              <i :class="superAdminTrigger.icon"></i>
            </span>
            {{ superAdminTrigger.text }}
          </button>

          <div class="trocar-conta-modal-header__acoes">
            <button
              v-if="checkSuperAdmin"
              type="button"
              class="trocar-conta-btn-header"
              :disabled="sincronizando || sincronizarBloqueadoPorCooldown"
              v-b-tooltip.noninteractive.hover
              :title="tituloSincronizar"
              @click="sincronizar"
            >
              <i
                :class="[
                  sincronizando
                    ? 'fas fa-spinner fa-spin'
                    : sincronizarBloqueadoPorCooldown
                    ? 'fas fa-clock'
                    : 'fas fa-sync-alt'
                ]"
              ></i>
              <template v-if="sincronizando">
                Sincronizando {{ progressoSincronizacao.atual }}/{{
                  progressoSincronizacao.total
                }}
              </template>
              <template v-else>Sincronizar</template>
            </button>

            <modal-wizard v-if="checkSuperAdmin"></modal-wizard>

            <button
              type="button"
              class="close trocar-conta-modal-header__fechar"
              aria-label="Fechar"
              @click="close()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </template>

      <div>
        <div class="trocar-conta-busca-linha">
          <div class="trocar-conta-busca-wrap">
            <b-form-input
              ref="inputBusca"
              v-model="filtroContas"
              placeholder="Buscar por nome, sigla, código ou documento"
              @input="debounce"
              @keyup.enter="changeSelected"
              @keyup.up="handleKeyUpDown"
              @keyup.down="handleKeyUpDown"
              :autofocus="true"
              class="trocar-conta-busca"
            ></b-form-input>
            <button
              v-if="filtroContas.length > 0"
              type="button"
              class="trocar-conta-busca__limpar"
              title="Limpar busca"
              @click="limparBusca"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <button
            v-if="temFiltrosAtivos"
            type="button"
            class="trocar-conta-busca__limpar-filtros"
            title="Limpar todos os filtros"
            @click="limparFiltros"
          >
            <i class="fas fa-sliders-h"></i> Limpar filtros
          </button>
        </div>

        <div class="trocar-conta-chips">
          <!-- Fileira 1 — Status | Categoria | Atividade -->
          <div class="trocar-conta-chips__fileira">
            <div class="trocar-conta-chip-group">
              <button
                v-for="chip in chipsFiltroStatus"
                :key="chip.valor"
                type="button"
                class="trocar-conta-chip"
                :class="{
                  'trocar-conta-chip--ativo':
                    filtroStatus === chip.valor ||
                    (chip.alterna && filtroStatus === chip.alterna)
                }"
                @click="toggleChip(chip)"
              >
                <i
                  v-if="chip.icone"
                  class="fas trocar-conta-chip-icone"
                  :class="[
                    chip.alterna && filtroStatus === chip.alterna
                      ? chip.alternaIcone
                      : chip.icone,
                    chip.cor
                      ? `trocar-conta-chip-icone--${
                          chip.alterna && filtroStatus === chip.alterna
                            ? chip.alternaCor
                            : chip.cor
                        }`
                      : null
                  ]"
                ></i>
                {{
                  chip.alterna && filtroStatus === chip.alterna
                    ? chip.alternaTexto
                    : chip.texto
                }}
              </button>
            </div>

            <!-- Modalidade — super-admin: botão único ciclo
            Parceria → Recorrência → Isenção → limpa. -->
            <template v-if="checkSuperAdmin">
              <button
                v-if="
                  filtroEnquadramento !== null || contasComEnquadramento > 0
                "
                type="button"
                class="trocar-conta-chip"
                :class="{
                  'trocar-conta-chip--ativo': filtroEnquadramento !== null
                }"
                @click="ciclarEnquadramento"
              >
                <i
                  class="fas trocar-conta-chip-icone"
                  :class="[
                    enquadramentoIcone,
                    `trocar-conta-chip-icone--${enquadramentoCor}`
                  ]"
                ></i>
                {{ textoEnquadramento }}
              </button>

              <!-- Atenção — super-admin: tri-state crítico/alerta/limpa.
              Mesmo padrão dos chips do v-for: ícone SEMPRE visível (usa
              chip.icone como classe), texto/CSS reagem ao nível ativo. -->
              <button
                type="button"
                class="trocar-conta-chip"
                :class="{
                  'trocar-conta-chip--ativo': filtroAtencao !== null
                }"
                :title="tituloCategoria(chipAtencao)"
                @click="toggleCategoria('filtroAtencao')"
              >
                <i
                  class="fas trocar-conta-chip-icone"
                  :class="[
                    chipAtencao.icone,
                    `trocar-conta-chip-icone--${corCategoria(chipAtencao)}`
                  ]"
                ></i>
                {{ textoCategoria(chipAtencao) }}
              </button>
            </template>

            <template v-if="checkSuperAdmin">
              <div class="trocar-conta-chip-group">
                <button
                  v-for="opcao in opcoesFiltroAtividade"
                  :key="opcao.valor"
                  type="button"
                  class="trocar-conta-chip"
                  :class="{
                    'trocar-conta-chip--ativo': filtroAtividade === opcao.valor
                  }"
                  @click="toggleFiltroAtividade(opcao.valor)"
                >
                  <i
                    v-if="opcao.icone"
                    class="fas trocar-conta-chip-icone"
                    :class="[
                      opcao.icone,
                      opcao.cor ? `trocar-conta-chip-icone--${opcao.cor}` : null
                    ]"
                  ></i>
                  {{ opcao.texto }}
                </button>
              </div>
            </template>
          </div>

          <!-- Fileira 2 (só super-admin): Iniciantes | CRM | Tier | Maturidade -->
          <div v-if="checkSuperAdmin" class="trocar-conta-chips__fileira">
            <!-- Iniciantes: conta recém-cadastrada ou implantação/go-live. -->
            <button
              type="button"
              class="trocar-conta-chip"
              :class="{ 'trocar-conta-chip--ativo': filtroIniciantes }"
              @click="toggleCategoria('filtroIniciantes')"
            >
              <i
                class="fas fa-rocket trocar-conta-chip-icone trocar-conta-chip-icone--principal"
              ></i>
              Iniciantes
            </button>

            <!-- Jornada (CRM): dropdown com a lista completa de estágios.
            Sem chip-group em volta (é um botão só, não grupo segmentado):
            .trocar-conta-chip-group tem overflow:hidden que corta o
            absolute do dropdown — sem ele o menu aparece inteiro. -->
            <div
              v-if="opcoesFiltroCrmEstagio.length > 0"
              class="trocar-conta-chip-dropdown"
              :class="{
                'trocar-conta-chip-dropdown--aberto': crmDropdownAberto
              }"
            >
              <button
                type="button"
                class="trocar-conta-chip"
                :class="{
                  'trocar-conta-chip--ativo': filtroCrmEstagio !== null
                }"
                @click="toggleCrmEstagio(null)"
              >
                <i
                  class="fas fa-bars-progress trocar-conta-chip-icone trocar-conta-chip-icone--principal"
                ></i>
                {{ textoCrmEstagio }}
                <i class="fas fa-caret-down trocar-conta-chip-seta"></i>
              </button>
              <div
                v-show="crmDropdownAberto"
                class="trocar-conta-chip-dropdown-items"
              >
                <button
                  v-for="opcao in opcoesFiltroCrmEstagio"
                  :key="opcao.valor"
                  type="button"
                  class="trocar-conta-chip-dropdown-item"
                  :class="{
                    'trocar-conta-chip-dropdown-item--ativo':
                      filtroCrmEstagio === opcao.valor
                  }"
                  @click="toggleCrmEstagio(opcao.valor)"
                >
                  {{ opcao.texto }}
                </button>
                <button
                  v-if="filtroCrmEstagio"
                  type="button"
                  class="trocar-conta-chip-dropdown-item trocar-conta-chip-dropdown-item--limpar"
                  @click="toggleCrmEstagio(filtroCrmEstagio)"
                >
                  Limpar filtro
                </button>
              </div>
            </div>

            <div class="trocar-conta-chip-group">
              <button
                v-for="opcao in opcoesFiltroTier"
                :key="opcao.valor"
                type="button"
                class="trocar-conta-chip"
                :class="{
                  'trocar-conta-chip--ativo': filtroTier === opcao.valor
                }"
                @click="toggleTier(opcao.valor)"
              >
                <i
                  class="trocar-conta-chip-icone"
                  :class="[
                    opcao.icone,
                    `trocar-conta-chip-icone--${opcao.cor}`
                  ]"
                ></i>
                {{ opcao.texto }}
              </button>
            </div>

            <div class="trocar-conta-chip-group">
              <button
                v-for="opcao in opcoesFiltroMaturidade"
                :key="opcao.valor"
                type="button"
                class="trocar-conta-chip"
                :class="{
                  'trocar-conta-chip--ativo': filtroMaturidade === opcao.valor
                }"
                @click="toggleMaturidade(opcao.valor)"
              >
                <i
                  class="trocar-conta-chip-icone"
                  :class="[
                    opcao.icone,
                    `trocar-conta-chip-icone--${opcao.cor}`
                  ]"
                ></i>
                {{ opcao.texto }}
              </button>
            </div>
          </div>
        </div>

        <div ref="lista" class="trocar-conta-lista">
          <!-- Atalho para as últimas contas acessadas. Só faz sentido para
          super-admin (é quem navega entre muitas contas diferentes); ids que
          não existem mais na lista corrente são descartados silenciosamente
          em contasRecentesExibicao. -->
          <div
            v-if="contasRecentesExibicao.length > 0"
            class="trocar-conta-recentes"
          >
            <div class="trocar-conta-recentes__cabecalho">
              <span>Acessadas recentemente</span>
              <button
                type="button"
                class="trocar-conta-recentes__limpar"
                title="Limpar acessadas recentemente"
                @click="limparRecentes"
              >
                Limpar
              </button>
            </div>
            <div class="trocar-conta-recentes__lista">
              <button
                v-for="conta in contasRecentesExibicao"
                :key="`recente-${conta.id}`"
                type="button"
                class="trocar-conta-recente-card"
                @click="trocarConta(conta.id)"
              >
                <span
                  class="trocar-conta-avatar trocar-conta-avatar--sm"
                  v-blur-sensitive
                >
                  {{ avatarTexto(conta) }}
                </span>
                <span class="trocar-conta-recente-card__textos">
                  <span
                    class="trocar-conta-recente-card__nome"
                    v-blur-sensitive
                    v-b-tooltip.noninteractive.hover
                    :title="`Código da conta: ${conta.id}`"
                  >
                    {{ nomeExibicao(conta) }}
                  </span>
                  <span
                    class="trocar-conta-recente-card__login"
                    v-blur-sensitive
                  >
                    @{{ conta.login }}
                  </span>
                </span>
              </button>
            </div>
          </div>

          <template v-for="item in itensVisiveis">
            <div
              v-if="item.tipo === 'cabecalho'"
              :key="item.chave"
              class="trocar-conta-secao-titulo"
            >
              <span>
                <i
                  class="fas fa-circle trocar-conta-dot"
                  :class="`trocar-conta-dot--${item.corDot}`"
                ></i>
                {{ item.texto }}
              </span>
              <span class="trocar-conta-secao-contador">
                {{ item.contador }} conta{{ item.contador === 1 ? "" : "s" }}
                <template v-if="listaEstaFiltrada">
                  filtrada{{ item.contador === 1 ? "" : "s" }}
                </template>
              </span>
            </div>

            <div
              v-else
              :key="item.chave"
              class="trocar-conta-card"
              :class="
                nivelAtencao(item.grupo.principal)
                  ? `trocar-conta-card--${nivelAtencao(item.grupo.principal)}`
                  : null
              "
            >
              <div class="trocar-conta-card__principal">
                <button
                  type="button"
                  class="trocar-conta-card__info linha-navegavel"
                  :class="{
                    'trocar-conta-card__info--atual': ehContaAtual(
                      item.grupo.principal
                    )
                  }"
                  :data-conta-id="item.grupo.principal.id"
                  @click="trocarConta(item.grupo.principal.id)"
                  @keydown="handleKeyUpDown"
                >
                  <span class="trocar-conta-avatar" v-blur-sensitive>
                    {{ avatarTexto(item.grupo.principal) }}
                  </span>

                  <span class="trocar-conta-card__textos">
                    <span class="trocar-conta-card__linha1">
                      <span
                        class="trocar-conta-card__nome"
                        v-blur-sensitive
                        v-b-tooltip.noninteractive.hover
                        :title="`Código da conta: ${item.grupo.principal.id}`"
                      >
                        {{ nomeExibicao(item.grupo.principal) }}
                      </span>
                      <i
                        v-if="item.grupo.principal.tipoPlano === 'PRE'"
                        class="fas fa-money-bill-1 trocar-conta-icone-pre"
                        v-b-tooltip.noninteractive.hover
                        title="Conta Pré-paga — o saldo é regido por créditos adquiridos, não pelo limite da conta"
                      ></i>
                      <i
                        v-if="enquadramentoInfo(item.grupo.principal)"
                        class="trocar-conta-icone-enquadramento"
                        :class="[
                          enquadramentoInfo(item.grupo.principal).icone,
                          `trocar-conta-icone-enquadramento--${
                            enquadramentoInfo(item.grupo.principal).codigo
                          }`
                        ]"
                        v-b-tooltip.noninteractive.hover
                        :title="enquadramentoInfo(item.grupo.principal).titulo"
                      ></i>
                      <span
                        v-if="ehContaAtual(item.grupo.principal)"
                        class="trocar-conta-badge-atual"
                      >
                        Atual
                      </span>
                    </span>
                    <!-- Login, código e documento numa linha só: são todos
                    identificadores da mesma natureza e a contagem de
                    subcontas migrou para o badge do botão que as expande. -->
                    <span class="trocar-conta-card__linha2">
                      <span
                        class="trocar-conta-tag trocar-conta-tag--copiavel"
                        v-b-tooltip.noninteractive.hover
                        title="Clique para copiar o login"
                        @click.stop="
                          copiar(item.grupo.principal.login, 'Login')
                        "
                      >
                        @{{ item.grupo.principal.login }}
                      </span>
                      <span
                        class="trocar-conta-tag trocar-conta-tag--copiavel trocar-conta-tag--sm"
                        v-b-tooltip.noninteractive.hover
                        title="Clique para copiar o código"
                        @click.stop="copiar(item.grupo.principal.id, 'Código')"
                      >
                        #{{ item.grupo.principal.id }}
                      </span>
                      <span
                        v-if="documentoNumero(item.grupo.principal)"
                        class="trocar-conta-tag trocar-conta-tag--copiavel trocar-conta-tag--sm"
                        v-b-tooltip.noninteractive.hover
                        title="Clique para copiar o CPF/CNPJ"
                        @click.stop="copiarDocumento(item.grupo.principal)"
                      >
                        § {{ documentoNumero(item.grupo.principal) }}
                      </span>
                    </span>
                  </span>

                  <!-- Bloco único de indicadores (WEL-5152): 5 posições fixas
                  (Tier/Maturidade/Fase/Atividade/Atenção) para alinhar entre
                  cards — quando o indicador não existe, mostra um traço no
                  lugar do ícone. O rótulo de cada posição só aparece no
                  hover do card (ver .trocar-conta-card:hover). -->
                  <span
                    v-if="checkSuperAdmin"
                    class="trocar-conta-card__indicadores"
                  >
                    <span class="trocar-conta-card__indicador">
                      <i
                        v-if="tierInfo(item.grupo.principal)"
                        class="trocar-conta-tier-icone"
                        :class="[
                          tierInfo(item.grupo.principal).icone,
                          `trocar-conta-tier-icone--${
                            tierInfo(item.grupo.principal).nivel
                          }`
                        ]"
                        v-b-tooltip.noninteractive.hover
                        :title="tierInfo(item.grupo.principal).titulo"
                      ></i>
                      <span v-else class="trocar-conta-card__indicador-vazio"
                        >—</span
                      >
                      <span class="trocar-conta-card__indicador-rotulo">
                        {{
                          tierInfo(item.grupo.principal)
                            ? tierInfo(item.grupo.principal).rotulo
                            : "Tier"
                        }}
                      </span>
                    </span>

                    <span class="trocar-conta-card__indicador">
                      <i
                        v-if="maturidadeInfo(item.grupo.principal)"
                        class="trocar-conta-maturidade-icone"
                        :class="[
                          maturidadeInfo(item.grupo.principal).icone,
                          `trocar-conta-maturidade-icone--${
                            maturidadeInfo(item.grupo.principal).nivel
                          }`
                        ]"
                        v-b-tooltip.noninteractive.hover
                        :title="maturidadeInfo(item.grupo.principal).titulo"
                      ></i>
                      <span v-else class="trocar-conta-card__indicador-vazio"
                        >—</span
                      >
                      <span class="trocar-conta-card__indicador-rotulo">
                        {{
                          maturidadeInfo(item.grupo.principal)
                            ? maturidadeInfo(item.grupo.principal).rotulo
                            : "Maturidade"
                        }}
                      </span>
                    </span>

                    <span class="trocar-conta-card__indicador">
                      <i
                        v-if="faseInfo(item.grupo.principal)"
                        class="trocar-conta-fase-icone"
                        :class="faseInfo(item.grupo.principal).icone"
                        v-b-tooltip.noninteractive.hover
                        :title="faseInfo(item.grupo.principal).titulo"
                      ></i>
                      <span v-else class="trocar-conta-card__indicador-vazio"
                        >—</span
                      >
                      <span class="trocar-conta-card__indicador-rotulo">
                        {{
                          faseInfo(item.grupo.principal)
                            ? faseInfo(item.grupo.principal).rotulo
                            : "Fase"
                        }}
                      </span>
                    </span>

                    <span class="trocar-conta-card__indicador">
                      <i
                        v-if="atividadeInfo(item.grupo.principal)"
                        class="fas trocar-conta-atividade-icone"
                        :class="[
                          atividadeInfo(item.grupo.principal).icone,
                          `trocar-conta-atividade-icone--${
                            atividadeInfo(item.grupo.principal).cor
                          }`
                        ]"
                        v-b-tooltip.noninteractive.hover
                        :title="atividadeInfo(item.grupo.principal).titulo"
                      ></i>
                      <span v-else class="trocar-conta-card__indicador-vazio"
                        >—</span
                      >
                      <span class="trocar-conta-card__indicador-rotulo">
                        {{
                          atividadeInfo(item.grupo.principal)
                            ? atividadeInfo(item.grupo.principal).rotulo
                            : "Atividade"
                        }}
                      </span>
                    </span>

                    <span class="trocar-conta-card__indicador">
                      <i
                        v-if="atencaoInfo(item.grupo.principal)"
                        class="fas fa-exclamation-triangle trocar-conta-atencao-icone"
                        v-b-tooltip.noninteractive.hover
                        :title="atencaoInfo(item.grupo.principal).titulo"
                      ></i>
                      <span v-else class="trocar-conta-card__indicador-vazio"
                        >—</span
                      >
                      <span class="trocar-conta-card__indicador-rotulo"
                        >Atenção</span
                      >
                    </span>
                  </span>

                  <span
                    v-if="saldos[item.grupo.principal.id]"
                    class="trocar-conta-saldo"
                    v-b-tooltip.noninteractive.hover
                    :title="tituloSaldo(item.grupo.principal.id)"
                  >
                    <span class="trocar-conta-saldo__cabecalho">
                      <span class="trocar-conta-saldo__rotulo">
                        {{
                          checkSuperAdmin
                            ? "Limite consumido"
                            : "Saldo utilizado"
                        }}
                      </span>
                      <span
                        class="trocar-conta-saldo__percentual"
                        :class="saldoCorClasse(item.grupo.principal.id)"
                      >
                        {{ percentualConsumo(item.grupo.principal.id) }}%
                      </span>
                    </span>
                    <span class="trocar-conta-saldo__barra">
                      <span
                        class="trocar-conta-saldo__uso"
                        :class="saldoCorClasse(item.grupo.principal.id)"
                        :style="{
                          width:
                            percentualConsumo(item.grupo.principal.id) + '%'
                        }"
                      ></span>
                    </span>
                    <span class="trocar-conta-saldo__texto">
                      {{
                        (
                          saldos[item.grupo.principal.id].credito -
                          saldos[item.grupo.principal.id].saldo
                        ).toLocaleString("pt-BR")
                      }}
                      <span class="trocar-conta-saldo__total">
                        usado de
                        {{
                          saldos[
                            item.grupo.principal.id
                          ].credito.toLocaleString("pt-BR")
                        }}
                      </span>
                      <i
                        v-if="riscoFaltarSaldo(item.grupo.principal.id)"
                        class="fas fa-exclamation-triangle trocar-conta-saldo__alerta"
                        v-b-tooltip.noninteractive.hover
                        title="No ritmo atual de consumo, o saldo deve terminar antes do fim do ciclo mensal."
                      ></i>
                      <button
                        v-if="podeConfigurarConta(item.grupo.principal)"
                        type="button"
                        class="trocar-conta-saldo__recalcular"
                        :disabled="
                          saldosCarregando.includes(item.grupo.principal.id)
                        "
                        v-b-tooltip.noninteractive.hover
                        :title="rotuloCalculoIndividual"
                        @click.stop="carregarSaldo(item.grupo.principal.id)"
                      >
                        <i
                          :class="
                            iconeCalculoIndividual(item.grupo.principal.id)
                          "
                        ></i>
                      </button>
                    </span>
                  </span>
                </button>

                <div class="trocar-conta-card__acoes">
                  <!-- WEL-5184: Campanhas (badge com contador) — super-admin -->
                  <span class="trocar-conta-card__acao-slot">
                    <b-button
                      v-if="checkSuperAdmin"
                      variant="link"
                      class="trocar-conta-acao-btn p-0 trocar-conta-acao-btn--com-contador"
                      :class="corBadgeCampanhas(item.grupo.principal)"
                      v-b-tooltip.noninteractive.hover="
                        tooltipCampanhas(item.grupo.principal)
                      "
                      @click.stop="abrirModalTimeline(item.grupo.principal)"
                    >
                      <i class="fas fa-rectangle-list"></i>
                      <span class="trocar-conta-badge-contador">{{
                        item.grupo.principal.campanhasAtivasQtde || 0
                      }}</span>
                    </b-button>
                  </span>

                  <!-- Slot fixo: Recursos (cubes) — super-admin -->
                  <span class="trocar-conta-card__acao-slot">
                    <b-dropdown
                      v-if="checkSuperAdmin"
                      no-caret
                      dropleft
                      variant="link"
                      toggle-class="trocar-conta-acao-btn p-0 trocar-conta-acao-btn--com-contador"
                      menu-class="trocar-conta-menu"
                      @click.native.stop
                      @show="carregarRecursosAtivos(item.grupo.principal)"
                    >
                      <template #button-content>
                        <i
                          class="fas fa-cubes"
                          v-b-tooltip.noninteractive.hover
                          title="Recursos ativos"
                        ></i>
                        <span class="trocar-conta-badge-contador">{{
                          item.grupo.principal.recursosAtivosQtde || 0
                        }}</span>
                      </template>
                      <div class="trocar-conta-recursos-lista">
                        <div
                          v-if="
                            statusRecursos(item.grupo.principal.id).carregando
                          "
                          class="trocar-conta-recursos-lista__mensagem"
                        >
                          Carregando...
                        </div>
                        <div
                          v-else-if="
                            statusRecursos(item.grupo.principal.id).lista
                              .length === 0
                          "
                          class="trocar-conta-recursos-lista__mensagem"
                        >
                          Nenhum recurso ativo.
                        </div>
                        <template v-else>
                          <div
                            v-for="nome in statusRecursos(
                              item.grupo.principal.id
                            ).lista"
                            :key="nome"
                            class="trocar-conta-recursos-lista__item"
                          >
                            <i class="fas fa-cube mr-2"></i>{{ nome }}
                          </div>
                        </template>
                      </div>
                    </b-dropdown>
                  </span>

                  <!-- Slot fixo: Info (i-circle) — sempre visível -->
                  <span class="trocar-conta-card__acao-slot">
                    <button
                      type="button"
                      class="trocar-conta-acao-btn"
                      v-b-popover.click.blur.html="
                        popoverInfo(item.grupo.principal)
                      "
                      v-b-tooltip.noninteractive.hover
                      title="Detalhes"
                      @click.stop
                    >
                      <i class="fas fa-info-circle"></i>
                    </button>
                  </span>

                  <!-- Slot fixo: Conexa/Faturamento (share-nodes) — super-admin + integração -->
                  <span class="trocar-conta-card__acao-slot">
                    <b-dropdown
                      v-if="
                        checkSuperAdmin && item.grupo.principal.ctiIntegracaoId
                      "
                      no-caret
                      dropleft
                      variant="link"
                      toggle-class="trocar-conta-acao-btn p-0 trocar-conta-acao-btn--com-alerta"
                      menu-class="trocar-conta-menu"
                      @click.native.stop
                      @show="carregarStatusFaturamento(item.grupo.principal)"
                    >
                      <template #button-content>
                        <i
                          class="fas fa-share-nodes trocar-conta-icone-conexa"
                          v-b-tooltip.noninteractive.hover
                          :title="
                            contaInadimplente(item.grupo.principal)
                              ? 'Faturamento — pendência administrativa'
                              : 'Faturamento'
                          "
                        ></i>
                        <span
                          v-if="contaInadimplente(item.grupo.principal)"
                          class="trocar-conta-badge-alerta"
                        ></span>
                      </template>
                      <b-dropdown-item
                        @click.prevent="abrirLinkConexa(item.grupo.principal)"
                        ><i class="fas fa-external-link-alt mr-2"></i>Abrir no
                        Conexa</b-dropdown-item
                      >
                      <b-dropdown-item
                        @click.prevent="reenviarCobranca(item.grupo.principal)"
                        ><i class="fas fa-file-arrow-up mr-2"></i>Reenviar
                        cobrança</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="
                          statusFaturamento(item.grupo.principal.id)
                            .hasLoginAccess
                        "
                        @click.prevent="
                          redefinirSenhaConexa(item.grupo.principal)
                        "
                        ><i class="fas fa-key mr-2"></i>Redefinir
                        senha</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-else-if="
                          !statusFaturamento(item.grupo.principal.id).carregando
                        "
                        @click.prevent="
                          liberarAreaClienteConexa(item.grupo.principal)
                        "
                        ><i class="fas fa-unlock-alt mr-2"></i>Liberar Área do
                        Cliente</b-dropdown-item
                      >
                    </b-dropdown>
                  </span>

                  <!-- Slot fixo: Mais (ellipsis-v) — admin/super-admin. Duas
                  permissões cobrem itens diferentes (ver podeVerUsuarios) —
                  o wrapper abre pra quem tiver qualquer uma das duas. -->
                  <span class="trocar-conta-card__acao-slot">
                    <b-dropdown
                      v-if="
                        podeConfigurarConta(item.grupo.principal) ||
                        podeVerUsuarios(item.grupo.principal)
                      "
                      no-caret
                      dropleft
                      variant="link"
                      toggle-class="trocar-conta-acao-btn p-0"
                      menu-class="trocar-conta-menu"
                    >
                      <template #button-content>
                        <i class="fas fa-ellipsis-v"></i>
                      </template>
                      <b-dropdown-item
                        @click.prevent="acaoConfiguracao(item.grupo.principal)"
                        ><i class="fas fa-cog mr-2"></i
                        >Configuração</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="podeVerUsuarios(item.grupo.principal)"
                        @click.prevent="acaoUsuarios(item.grupo.principal)"
                        ><i class="fas fa-users mr-2"></i
                        >Usuários</b-dropdown-item
                      >
                      <!-- WEL-5184: Agente/Sistema — modal já existe
                      (ModalAgenteSistema.vue), personificado com
                      contaId da conta selecionada. -->
                      <b-dropdown-item
                        v-if="checkSuperAdmin"
                        @click.prevent="
                          abrirModalAgenteSistema(item.grupo.principal)
                        "
                        ><i class="fas fa-circle-nodes mr-2"></i
                        >Conectores</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="!item.grupo.principal.contaPrincipalId"
                        @click.prevent="acaoCadastrar(item.grupo.principal)"
                        ><i class="fas fa-plus mr-2"></i>Cadastrar
                        Conta</b-dropdown-item
                      >
                      <b-dropdown-item
                        @click.prevent="acaoEnviarManual(item.grupo.principal)"
                        ><i class="fa fa-upload mr-2"></i>Enviar
                        Manual</b-dropdown-item
                      >
                      <b-dropdown-item
                        @click.prevent="acaoAlterarSenha(item.grupo.principal)"
                        ><i class="fas fa-key mr-2"></i>Alterar
                        Senha</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="checkSuperAdmin"
                        @click.prevent="
                          alterarStatusConta(item.grupo.principal)
                        "
                        ><i
                          :class="
                            item.grupo.principal.status === 'A'
                              ? 'fas fa-lock mr-2'
                              : 'fas fa-unlock mr-2'
                          "
                        ></i
                        >{{
                          item.grupo.principal.status === "A"
                            ? "Bloquear"
                            : "Desbloquear"
                        }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </span>

                  <!-- Slot fixo: expandir/recolher subcontas -->
                  <span class="trocar-conta-card__acao-slot">
                    <button
                      v-if="
                        !ocultarSubcontas &&
                        item.grupo.subcontasVisiveis.length > 0
                      "
                      type="button"
                      class="trocar-conta-card__toggle trocar-conta-acao-btn--com-contador"
                      @click="
                        alternarExpandirPrincipal(item.grupo.principal.id)
                      "
                      v-b-tooltip.noninteractive.hover
                      :title="
                        grupoEstaExpandido(item.grupo)
                          ? 'Recolher subcontas'
                          : `Expandir ${
                              item.grupo.subcontasVisiveis.length
                            } subconta${
                              item.grupo.subcontasVisiveis.length === 1
                                ? ''
                                : 's'
                            }`
                      "
                    >
                      <i
                        :class="
                          grupoEstaExpandido(item.grupo)
                            ? 'fas fa-chevron-up'
                            : 'fas fa-chevron-down'
                        "
                      ></i>
                      <span class="trocar-conta-badge-contador">{{
                        item.grupo.subcontasVisiveis.length
                      }}</span>
                    </button>
                  </span>
                </div>
              </div>

              <div
                v-if="
                  !ocultarSubcontas &&
                  grupoEstaExpandido(item.grupo) &&
                  item.grupo.subcontasVisiveis.length > 0
                "
                class="trocar-conta-card__subcontas"
              >
                <div class="trocar-conta-card__subcontas-cabecalho">
                  <span
                    >Subcontas ({{ item.grupo.subcontasVisiveis.length }})</span
                  >
                </div>

                <div
                  v-for="sub in subcontasParaExibir(item.grupo)"
                  :key="sub.id"
                  class="trocar-conta-subconta"
                >
                  <button
                    type="button"
                    class="trocar-conta-subconta__info linha-navegavel"
                    :class="{
                      'trocar-conta-card__info--atual': ehContaAtual(sub)
                    }"
                    :data-conta-id="sub.id"
                    @click="trocarConta(sub.id)"
                    @keydown="handleKeyUpDown"
                  >
                    <span class="trocar-conta-subconta__textos">
                      <span
                        class="trocar-conta-subconta__nome"
                        v-blur-sensitive
                        v-b-tooltip.noninteractive.hover
                        :title="`Código da conta: ${sub.id}`"
                      >
                        {{ nomeExibicao(sub) }}
                      </span>
                      <span class="trocar-conta-meta" v-blur-sensitive>
                        <span
                          class="trocar-conta-tag trocar-conta-tag--copiavel"
                          v-b-tooltip.noninteractive.hover
                          title="Clique para copiar o login"
                          @click.stop="copiar(sub.login, 'Login')"
                          >@{{ sub.login }}</span
                        >
                        <span
                          class="trocar-conta-tag trocar-conta-tag--copiavel"
                          v-b-tooltip.noninteractive.hover
                          title="Clique para copiar o código"
                          @click.stop="copiar(sub.id, 'Código')"
                          >#{{ sub.id }}</span
                        >
                      </span>
                    </span>
                    <i
                      class="fas fa-circle trocar-conta-dot"
                      :class="`trocar-conta-dot--${
                        statusInfo(sub.status).classe
                      }`"
                      v-b-tooltip.noninteractive.hover
                      :title="statusInfo(sub.status).texto"
                    ></i>
                  </button>

                  <div class="trocar-conta-subconta__acoes">
                    <button
                      type="button"
                      class="trocar-conta-acao-btn trocar-conta-acao-btn--sm"
                      v-b-popover.click.blur.html="popoverInfo(sub)"
                      v-b-tooltip.noninteractive.hover
                      title="Detalhes"
                      @click.stop
                    >
                      <i class="fas fa-info-circle"></i>
                    </button>

                    <b-dropdown
                      v-if="podeConfigurarConta(sub) || podeVerUsuarios(sub)"
                      no-caret
                      dropleft
                      variant="link"
                      toggle-class="trocar-conta-acao-btn trocar-conta-acao-btn--sm p-0"
                      menu-class="trocar-conta-menu"
                    >
                      <template #button-content>
                        <i class="fas fa-ellipsis-v"></i>
                      </template>
                      <b-dropdown-item @click.prevent="acaoConfiguracao(sub)"
                        ><i class="fas fa-cog mr-2"></i
                        >Configuração</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="podeVerUsuarios(sub)"
                        @click.prevent="acaoUsuarios(sub)"
                        ><i class="fas fa-users mr-2"></i
                        >Usuários</b-dropdown-item
                      >
                      <b-dropdown-item @click.prevent="acaoEnviarManual(sub)"
                        ><i class="fa fa-upload mr-2"></i>Enviar
                        Manual</b-dropdown-item
                      >
                      <b-dropdown-item @click.prevent="acaoAlterarSenha(sub)"
                        ><i class="fas fa-key mr-2"></i>Alterar
                        Senha</b-dropdown-item
                      >
                      <!-- WEL-5197: algumas subcontas têm sistemas próprios,
                      mesmo sendo exceção — o item passa a existir aqui
                      também, não só na principal. -->
                      <b-dropdown-item
                        v-if="checkSuperAdmin"
                        @click.prevent="abrirModalAgenteSistema(sub)"
                        ><i class="fas fa-circle-nodes mr-2"></i
                        >Conectores</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="checkSuperAdmin"
                        @click.prevent="alterarStatusConta(sub)"
                        ><i
                          :class="
                            sub.status === 'A'
                              ? 'fas fa-lock mr-2'
                              : 'fas fa-unlock mr-2'
                          "
                        ></i
                        >{{
                          sub.status === "A" ? "Bloquear" : "Desbloquear"
                        }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </div>

                <button
                  v-if="
                    !termoBusca.trim() &&
                    item.grupo.subcontasVisiveis.length >
                      limiteSubcontasPadrao &&
                    !subcontasExpandidas.includes(item.grupo.principal.id)
                  "
                  type="button"
                  class="trocar-conta-ver-todas"
                  @click="expandirTodasSubcontas(item.grupo.principal.id)"
                >
                  Ver todas as
                  {{ item.grupo.subcontasVisiveis.length }} subcontas
                </button>
              </div>
            </div>
          </template>

          <!-- Sentinela para a rolagem incremental: fica sempre presente (não
          é v-if) para o IntersectionObserver não precisar ser recriado a
          cada bloco carregado — carregarMaisItens() já é um no-op quando a
          janela alcança o fim de itensLista. -->
          <div ref="sentinelaLista" class="trocar-conta-lista-sentinela"></div>

          <p v-if="itensLista.length === 0" class="text-muted text-center my-4">
            Nenhuma conta encontrada.
          </p>
        </div>
      </div>
    </b-modal>

    <modal-configuracao
      v-if="contaConfig"
      ref="modalConfiguracao"
      :conta="contaConfig"
      tipoBotao="nenhum"
      :exibirAbasConta="exibirAbasConfig"
    ></modal-configuracao>

    <modal-adicionar-conta
      v-if="contaAcao"
      ref="modalCadastrar"
      :contaPrincipal="contaAcao"
      tipoBotao="nenhum"
      @conta:cadastrada="contaCadastrada"
    ></modal-adicionar-conta>

    <modal-enviar-manual
      v-if="contaAcao"
      ref="modalEnviarManual"
      :conta="contaAcao"
      tipoBotao="nenhum"
    ></modal-enviar-manual>

    <modal-alterar-senha
      v-if="contaAcao"
      ref="modalAlterarSenha"
      :id="contaAcao.id"
      url="conta/alterarSenha"
      titulo="Alterar Senha da Conta"
      :exigirSenhaAtual="false"
      tipoBotao="nenhum"
    ></modal-alterar-senha>

    <modal-usuarios
      v-if="contaAcao"
      ref="modalUsuarios"
      :conta="contaAcao"
      tipoBotao="nenhum"
    ></modal-usuarios>

    <ModalTimeline ref="modalTimeline" />
    <ModalAgenteSistema ref="modalAgenteSistema" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/core/services/api.service";
import Utils from "@/core/utils/Utils";
import Swal from "sweetalert2";
import moment from "moment";
import ModalConfiguracao from "@/view/pages/painel/conta/ModalConfiguracao.vue";
import ModalAdicionarConta from "@/view/pages/painel/conta/ModalAdicionarConta.vue";
import ModalEnviarManual from "@/view/pages/painel/conta/ModalEnviarManual.vue";
import ModalAlterarSenha from "@/view/components/ModalAlterarSenha.vue";
import ModalUsuarios from "@/view/pages/painel/conta/ModalUsuarios.vue";
import ModalWizard from "@/view/pages/painel/conta/wizard/ModalWizard.vue";
import ModalTimeline from "./ModalTimeline.vue";
import ModalAgenteSistema from "../../automacao/components/ModalAgenteSistema.vue";

// Central de Contas: nº de contas buscado por página no endpoint
// central-contas (só super-admin). A base inteira cabe em poucas chamadas
// sequenciais — ver carregarContasCentral(), usado tanto em abrir() quanto
// ao final da sincronização em massa.
const CONTAS_POR_PAGINA = 100;

// Intervalo do poll de progresso da sincronização em massa (job em fila no
// servidor — ver sincronizar()/acompanharSincronizacao()).
const INTERVALO_POLL_SINCRONIZACAO = 2000;

// Corta o poll se passar muito tempo sem chegar em 100% (ex.: um bloco do
// job travou/lançou exceção fora do padrão e cin_saldo_atualizado_em nunca
// fecha o total) — evita spinner preso pra sempre (WEL-5157).
const POLLS_MAXIMOS_SINCRONIZACAO = 300; // 300 * 2s = 10min

// Renderização incremental da lista: evita montar de uma vez centenas de
// cards (trava a UI) sem recorrer a paginação visível — os itens extras
// entram em blocos conforme o usuário rola até o fim do já renderizado.
const TAMANHO_INICIAL_LISTA = 40;
const BLOCO_LISTA = 40;

const MAX_CONTAS_RECENTES = 5;

// WEL-5152: o botão de contexto do Super Admin ganha cara nova a cada
// abertura — ícone e texto são sorteados desta lista. Assim ninguém mais
// precisa ver "Administrador do Sistema" o dia inteiro.
const SUPER_ADMIN_TRIGGERS = [
  { icon: "fas fa-user-astronaut", text: "Orbitar" },
  { icon: "fab fa-space-awesome", text: "Spore Jump" },
  { icon: "fas fa-hand-spock", text: "Live long and prosper" },
  { icon: "fas fa-atom", text: "Salto Quântico" },
  { icon: "fas fa-door-open", text: "Abrir Portal" },
  { icon: "fas fa-hand-sparkles", text: "Transmutar" },
  { icon: "fas fa-wand-sparkles", text: "Conjurar" },
  { icon: "fas fa-bolt", text: "Canalizar" },
  { icon: "fas fa-infinity", text: "Transcender" },
  { icon: "fas fa-angles-up", text: "Ascender" },
  { icon: "fas fa-hat-wizard", text: "Tornar-se Onisciente" },
  { icon: "fas fa-gamepad", text: "Ativar God Mode" },
  { icon: "fab fa-codepen", text: "Acessar a Matrix" },
  { icon: "fas fa-hand-fist", text: "Estalar de Dedos" },
  { icon: "fas fa-hands-praying", text: "Dança Metamoru" },
  { icon: "fas fa-hands-holding-circle", text: "Hadouken" },
  { icon: "fas fa-tornado", text: "Mundo Invertido" }
];

const STATUS_INFO = {
  A: { texto: "Ativa", classe: "ativa" },
  I: { texto: "Inativa", classe: "inativa" },
  B: { texto: "Bloqueada", classe: "bloqueada" },
  S: { texto: "Suspensa", classe: "suspensa" }
};

// Ícone + cor do indicador de Atividade (ver atividadeInfo). Só existe para
// contas principais e só é exibido para super-admin — o indicador vem null
// em subcontas e para contas sem base histórica suficiente.
const ATIVIDADE_INFO = {
  MUITO_ATIVA: {
    icone: "fa-sun",
    cor: "muito-ativa",
    rotulo: "Aceler.",
    texto: "Acelerando — volume bem acima do costume da conta"
  },
  NORMAL: {
    icone: "fa-water",
    cor: "normal",
    rotulo: "Normal",
    texto: "Atividade normal para o padrão da conta"
  },
  REDUCAO: {
    icone: "fa-cloud-sun",
    cor: "reducao",
    rotulo: "Reduzindo",
    texto: "Reduzindo — volume abaixo do costume da conta"
  },
  QUASE_PARADA: {
    icone: "fa-snowflake",
    cor: "quase-parada",
    rotulo: "Estagnada",
    texto: "Estagnada — pouco ou nenhum envio recente"
  }
};

// Texto do indicador de Fase (ver faseInfo). Assim como a Atividade, só
// existe em contas principais e só é exibido para super-admin; fase null
// significa conta madura (ou sem indicador ainda) e o ícone não aparece.
const FASE_INFO = {
  IMPLANTACAO: {
    rotulo: "Implant.",
    texto:
      "Implantação — conta em fase inicial (cadastrada há pouco e/ou com projeto ativo no CRM, sem envios ainda)"
  },
  GO_LIVE: {
    rotulo: "Go Live",
    texto: "Go Live — primeiro envio recente"
  }
};

// Ícone + tooltip do Tier do cliente (WEL-5146). Tier é uma classificação
// comercial/estratégica do cliente (1, 2 ou 3), editável por super-admin.
// Retorna null quando o cliente não tem tier definido (sem ícone no card).
const TIER_INFO = {
  1: {
    icone: "fas fa-star",
    rotulo: "Tier 1",
    titulo: "Tier 1 — cliente estratégico"
  },
  2: {
    icone: "fas fa-star-half-stroke",
    rotulo: "Tier 2",
    titulo: "Tier 2 — cliente intermediário"
  },
  3: {
    icone: "far fa-star",
    rotulo: "Tier 3",
    titulo: "Tier 3 — cliente básico"
  }
};

// Ícone + tooltip do indicador de Maturidade (WEL-5147). Combina posição
// no ranking Conexão Única (engajamento) com porte da conta (faturamento
// 6M + recursos ativos). Só super-admin, só contas principais. Sequência
// visual (do início da jornada até o topo): folha pequena (semente) →
// broto verde-claro → planta com folhas (verde médio) → árvore (verde escuro).
const MATURIDADE_INFO = {
  1: {
    icone: "fas fa-leaf",
    rotulo: "Básico",
    titulo: "Básico — sem ranking, ou ranqueada mas sem porte relevante",
    cor: "#8b5a2b"
  },
  2: {
    icone: "fas fa-seedling",
    rotulo: "Interm.",
    titulo:
      "Intermediário — presente no ranking de engajamento E com porte relevante",
    cor: "#7cb342"
  },
  3: {
    icone: "fab fa-pagelines",
    rotulo: "Avançado",
    titulo: "Avançado — top 30% da Conexão Única",
    cor: "#4c9a4c"
  },
  4: {
    icone: "fas fa-tree",
    rotulo: "Referênc.",
    titulo: "Referência — top 10% da Conexão Única",
    cor: "#198754"
  }
};

// Ícone de enquadramento comercial (WEL-5157) — con_motivo_isencao só é
// relevante quando con_faturar <> 'S' (ver Faturamento.vue e
// ContaIndicadorService::SEM_MOTIVO_ISENCAO). 'P' migrou de "Pacote" para
// "Parceria"; "Pacote/Recorrencia" agora usa 'R' (Marcel, 2026-07-20).
const ENQUADRAMENTO_INFO = {
  I: {
    icone: "fas fa-gift",
    titulo: "Isenção — não gera cobrança",
    cor: "#6a6579"
  },
  P: {
    icone: "fas fa-handshake-simple",
    titulo: "Parceria — condições comerciais especiais",
    cor: "#7c3aed"
  },
  R: {
    icone: "fas fa-file-circle-check",
    titulo: "Recorrência — cobrança automática, sem cadastro no Conexa",
    cor: "#0b4c8c"
  }
};

// Rótulos amigáveis do indicador de Atenção (WEL-5148). Cada conta pode
// acumular vários motivos ao mesmo tempo (ver atencaoInfo) — usados no
// tooltip do ícone único que representa "esta conta precisa de atenção".
const ATENCAO_LABELS = {
  SALDO_RISCO: "Saldo em risco de acabar",
  SEM_ENVIO_RECENTE: "Sem enviar/receber há mais tempo que o configurado",
  CAMPANHA_FALHANDO: "Campanhas falhando com frequência",
  CRM_PARADO: "Projeto parado no Atendare",
  IMPLANTACAO_TRAVADA: "Implantação travada (sem primeiro envio)",
  CLIENTE_NAO_FATURADO: "Sem fatura gerada este mês",
  SEM_MOTIVO_ISENCAO: "Não fatura e sem motivo definido (isento/pacote)",
  FATURAMENTO_SEM_INTEGRACAO_CONEXA:
    "Faturamento habilitado sem integração com o Conexa",
  CONEXA_INADIMPLENTE: "Cobrança vencida em aberto no Conexa"
};

export default {
  name: "CentralContas",
  components: {
    "modal-configuracao": ModalConfiguracao,
    "modal-adicionar-conta": ModalAdicionarConta,
    "modal-enviar-manual": ModalEnviarManual,
    "modal-alterar-senha": ModalAlterarSenha,
    "modal-usuarios": ModalUsuarios,
    "modal-wizard": ModalWizard,
    ModalTimeline,
    ModalAgenteSistema
  },
  data() {
    return {
      contas: [],
      idContaSelecionada: null,
      filtroContas: "",
      termoBusca: "",
      // Filtros da Central, organizados por GRUPO (WEL-5149, revisão do
      // comportamento de seleção — cada grupo tem uma regra própria:
      //   - filtroStatus: mutuamente exclusivo (Todas | Ativas | Inativas).
      //   - filtroPrincipais/filtroIniciantes/filtroAtencao: toggles
      //     INDEPENDENTES entre si e do status — combinam em E (ex.: Ativas
      //     + Principais + Atenção ao mesmo tempo é uma combinação válida).
      //   - filtroAtividade: mutuamente exclusivo (Muito ativas | Redução |
      //     Quase paradas) — clicar de novo no mesmo chip limpa o filtro.
      //   - filtroTier / filtroMaturidade: mutuamente exclusivos, mesma
      //     regra de clique-de-novo-limpa.
      // Nenhum desses grupos permite 2 valores do MESMO grupo ao mesmo tempo
      // — só combinações ENTRE grupos diferentes.
      filtroStatus: "ativas",
      filtroPrincipais: false,
      filtroIniciantes: false,
      // Tri-state (WEL-5152): null → "critico" → "alerta" → null. Mesmo
      // padrão do chip Ativas/Inativas, mas por urgência da Atenção.
      filtroAtencao: null,
      filtroAtividade: null,
      filtroTier: null,
      filtroMaturidade: null,
      filtroEnquadramento: null,
      filtroCrmEstagio: null,
      crmDropdownAberto: false,
      debounceTimeout: null,
      limiteSubcontasPadrao: 3,
      principaisExpandidos: [],
      subcontasExpandidas: [],
      contaConfig: null,
      exibirAbasConfig: false,
      contaAcao: null,
      saldos: {},
      saldosCarregando: [],
      // Usado só pelo cache local de saldos de não super-admin (ver
      // carregarCacheSaldos/salvarCacheSaldos) — super-admin não grava mais
      // esse cache.
      saldosAtualizadoEm: null,
      sincronizando: false,
      progressoSincronizacao: { atual: 0, total: 0 },
      pollSincronizacaoTentativas: 0,
      // WEL-5157: instante (ISO) em que o cooldown de 4h do botão manual
      // libera de novo — null quando já pode sincronizar. Carregado ao
      // abrir a Central (carregarDisponibilidadeSincronizacao), pra
      // desabilitar o botão de cara em vez de deixar o usuário descobrir
      // via 429 depois do clique.
      sincronizarDisponivelEm: null,
      desbloqueioTimerSincronizacao: null,
      // WEL-5152: ícone + texto do botão de contexto de super-admin — sorteado
      // em abrir(), mesmo ícone por toda a sessão do modal.
      superAdminTrigger: null,
      // Grupo 1 — Status (mutuamente exclusivo): segmented control, cantos
      // arredondados só nas pontas do grupo.
      chipsFiltroStatus: [
        { valor: "todas", texto: "Todas", icone: "fa-list" },
        {
          valor: "ativas",
          texto: "Ativas",
          icone: "fa-circle",
          cor: "ativa",
          alterna: "inativas",
          alternaTexto: "Inativas",
          alternaIcone: "fa-circle",
          alternaCor: "inativa"
        }
      ],
      // Grupo 2 — Categoria (toggles independentes entre si, combinam em E
      // com todos os outros grupos): chips soltas, não seladas como
      // segmented control — visualmente sinaliza que dá pra marcar mais de
      // uma ao mesmo tempo (diferente do Grupo 1/3/4, que são radio).
      chipsFiltroCategoria: [
        {
          chave: "filtroPrincipais",
          texto: "Principais",
          icone: "fa-certificate",
          cor: "principal"
        },
        {
          chave: "filtroIniciantes",
          texto: "Iniciantes",
          icone: "fa-rocket",
          cor: "principal",
          // Depende de indicador.fase, dado exclusivo de super-admin em
          // todo o resto da tela — vazou pra não super-admin até WEL-5152
          // porque este grupo (diferente de Atividade/Tier/Maturidade) não
          // tinha proteção nenhuma no template.
          soSuperAdmin: true
        },
        {
          chave: "filtroAtencao",
          texto: "Atenção",
          icone: "fa-exclamation-triangle",
          cor: "atencao",
          // Depende de indicador.atencaoMotivos, mesmo caso do Iniciantes.
          soSuperAdmin: true,
          // Ciclo de urgência: 1º clique mostra só o que impacta agora
          // (vermelho), 2º só as pendências de cadastro (âmbar), 3º limpa.
          niveis: [
            { valor: "critico", texto: "Crítico", cor: "atencao" },
            { valor: "alerta", texto: "Alerta", cor: "atencao-leve" },
            { valor: "pendencia", texto: "Pendência", cor: "pendencia" }
          ]
        }
      ],
      // Status do dropdown Faturamento (WEL-5149), carregado sob demanda
      // (@show) por conta — { [contaId]: { carregando, hasLoginAccess, login } }.
      faturamentoStatus: {},
      // Lista de recursos ativos (WEL-5150), carregada sob demanda (@show)
      // por conta — { [contaId]: { carregando, lista } }. A contagem no
      // badge já vem pronta no payload (recursosAtivosQtde).
      recursosAtivos: {},
      // WEL-5184: a timeline de campanhas (24h) agora é exibida em modal
      // dedicado (ModalTimeline.vue), sem cache local — cada abertura
      // refaz a chamada à API.
      diasContaRecente: 120,
      tamanhoJanela: TAMANHO_INICIAL_LISTA,
      contasRecentesIds: []
    };
  },
  created() {
    // Instâncias de IntersectionObserver/handlers de scroll/timers não são
    // estado de template — ficam fora de data() para não virarem reativas à
    // toa.
    this.observadorLista = null;
    this.scrollFallbackContainer = null;
    this.scrollFallbackHandler = null;
    this.pollSincronizacao = null;
    this.fecharCrmDropdown = (e) => {
      if (
        this.crmDropdownAberto &&
        !e.target.closest(".trocar-conta-chip-dropdown")
      ) {
        this.crmDropdownAberto = false;
      }
    };
  },
  mounted() {
    // Cache de saldos em localStorage só vale para não super-admin: o
    // super-admin passa a usar os indicadores vindos da Central de Contas
    // (ver carregarContasCentral), sem cache local.
    if (!this.checkSuperAdmin) {
      this.carregarCacheSaldos();
    }
    this.carregarRecentes();
    document.addEventListener("click", this.fecharCrmDropdown);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.fecharCrmDropdown);
    this.pararObservadorLista();
    this.pararPollSincronizacao();
  },
  computed: {
    ...mapGetters([
      "currentUserPersonalInfo",
      "hasAccount",
      "isAccountAdmin",
      "contasParaTroca",
      "checkSuperAdmin",
      "hasPermission",
      "deveQuestionarSuperAdmin"
    ]),

    ocultarSubcontas() {
      return this.filtroPrincipais;
    },

    // Chips do Grupo 2 visíveis pro usuário atual — "Iniciantes" e "Atenção"
    // dependem de indicador.fase/atencaoMotivos, dados exclusivos de
    // super-admin em todo o resto da tela (WEL-5157: estavam vazando pra
    // não super-admin porque este grupo não tinha a mesma proteção
    // v-if="checkSuperAdmin" que os grupos 3/4/5 já tinham).
    chipsFiltroCategoriaVisiveis() {
      return this.chipsFiltroCategoria.filter(
        (chip) => !chip.soSuperAdmin || this.checkSuperAdmin
      );
    },

    // Grupo 3 de filtros (ver chipsFiltroStatus/chipsFiltroCategoria acima):
    // Atividade é radio (filtroAtividade), não multi-select — ver toggleFiltroAtividade.
    opcoesFiltroAtividade() {
      return [
        {
          valor: "muito-ativas",
          texto: "Acelerando",
          icone: "fa-sun",
          cor: "muito-ativa"
        },
        {
          valor: "reducao-atividade",
          texto: "Reduzindo",
          icone: "fa-cloud-sun",
          cor: "reducao"
        },
        {
          valor: "quase-paradas",
          texto: "Estagnada",
          icone: "fa-snowflake",
          cor: "quase-parada"
        }
      ];
    },

    // Grupo 4 — Tier, radio (filtroTier). Ícone/cor vêm de TIER_INFO, a
    // mesma fonte do ícone no card — os chips funcionam como legenda.
    opcoesFiltroTier() {
      return [1, 2, 3].map((tier) => ({
        valor: tier,
        texto: `Tier ${tier}`,
        icone: TIER_INFO[tier].icone,
        cor: `t${tier}`
      }));
    },

    // Grupo 5 — Maturidade, radio (filtroMaturidade). Ícone/cor vêm de
    // MATURIDADE_INFO, a mesma fonte do ícone no card.
    opcoesFiltroMaturidade() {
      return [1, 2, 3, 4].map((nivel) => ({
        valor: nivel,
        texto: MATURIDADE_INFO[nivel].titulo.split(" — ")[0],
        icone: MATURIDADE_INFO[nivel].icone,
        cor: `m${nivel}`
      }));
    },

    // Grupo 6 — Estágio do CRM, radio (filtroCrmEstagio). Os valores são
    // 100% dinâmicos, lidos do que está de fato em conta_indicador — não
    // hardcodar nomes de estágio: o Atendare pode renomear/reorganizar o
    // pipeline, e a Wellon pode até trocar de CRM no futuro (pedido do
    // Marcel, WEL-5157). Por isso não tem ícone/cor por valor como
    // Tier/Maturidade — todos usam o mesmo ícone genérico de pipeline.
    // Enquadramento comercial (WEL-5157): quantas contas principais
    // carregadas têm motivoIsencao válido — usado pra mostrar/esconder
    // o chip (mesmo padrão do filtro CRM).
    contasComEnquadramento() {
      return this.contas.filter(
        (c) =>
          !c.contaPrincipalId &&
          c.motivoIsencao &&
          ENQUADRAMENTO_INFO[c.motivoIsencao]
      ).length;
    },

    textoEnquadramento() {
      if (!this.filtroEnquadramento) return "Modalidade";
      return ENQUADRAMENTO_INFO[this.filtroEnquadramento].titulo
        .split("—")[0]
        .trim();
    },

    enquadramentoCor() {
      if (!this.filtroEnquadramento) return "ativa";
      if (this.filtroEnquadramento === "P") return "principal";
      if (this.filtroEnquadramento === "R") return "atencao";
      return "ativa";
    },

    // ENQUADRAMENTO_INFO é uma const do módulo do <script> — o <template>
    // compila para um módulo à parte, sem acesso a esse closure (por isso
    // não pode ser referenciada direto no template, só aqui).
    // O chip Atenção é usado direto no template (fora do v-for de
    // chipsFiltroCategoriaVisiveis), mas textoCategoria/corCategoria/
    // tituloCategoria precisam do objeto completo (com niveis/texto/cor).
    chipAtencao() {
      return this.chipsFiltroCategoria.find((c) => c.chave === "filtroAtencao");
    },

    enquadramentoIcone() {
      if (!this.filtroEnquadramento) return "fas fa-handshake-angle";
      return ENQUADRAMENTO_INFO[this.filtroEnquadramento].icone;
    },

    opcoesFiltroCrmEstagio() {
      const estagios = new Set();

      this.contas.forEach((conta) => {
        const estagio = conta.indicador?.crmEstagio;
        if (!conta.contaPrincipalId && estagio) {
          estagios.add(estagio);
        }
      });

      return Array.from(estagios)
        .sort((a, b) => a.localeCompare(b, "pt-BR"))
        .map((estagio) => ({ valor: estagio, texto: estagio }));
    },

    textoCrmEstagio() {
      return this.filtroCrmEstagio || "Jornada";
    },

    // Sincronização em massa dos indicadores: agora é um job em fila no
    // servidor (sem janela semanal nem lotes no cliente). O botão só
    // desabilita enquanto o acompanhamento (poll) está ativo.
    // WEL-5157: cooldown de 4h conhecido de antemão (via conta_indicador,
    // ver carregarDisponibilidadeSincronizacao) — o botão nasce desabilitado
    // quando aplicável, em vez de só descobrir depois de um clique que
    // resultaria em 429.
    sincronizarBloqueadoPorCooldown() {
      return (
        !!this.sincronizarDisponivelEm &&
        moment(this.sincronizarDisponivelEm).isAfter(moment())
      );
    },

    tituloSincronizar() {
      if (this.sincronizando) {
        return "Recalculando os indicadores de todas as contas ativas...";
      }

      if (this.sincronizarBloqueadoPorCooldown) {
        return `Sincronizado recentemente — disponível às ${moment(
          this.sincronizarDisponivelEm
        ).format("HH:mm")}.`;
      }

      return "Recalcula todos os indicadores (limite, atividade, fase, CRM, maturidade, atenção) de todas as contas ativas no servidor.";
    },

    // Rótulo e ícone do botão de cálculo individual mudam só para
    // super-admin (visão de "Limite Disponível"); os demais administradores
    // continuam vendo "Saldo" — nenhuma mudança de comportamento para eles.
    rotuloCalculoIndividual() {
      return this.checkSuperAdmin
        ? "Calcular limite de envios"
        : "Calcular saldo";
    },

    // Agrupa a lista plana de contas em contas principais + suas subcontas,
    // já aplicando o termo de busca (nome, login, sigla, id ou documento).
    // Uma subconta cujo pai não esteja na lista (ex.: usuário vinculado só à
    // subconta) é tratada como um grupo "principal" próprio, sem cair fora da tela.
    gruposContas() {
      const contasPorId = new Map(
        this.contas.map((conta) => [conta.id, conta])
      );
      const termo = this.termoBusca.trim().toLowerCase();
      const termoDigitos = termo.replace(/\D/g, "");

      const correspondeTermo = (conta) => {
        if (!termo) {
          return true;
        }

        const documentoLimpo = Utils.limparDocumento(
          conta.documento
        ).toLowerCase();

        return (
          this.nomeExibicao(conta).toLowerCase().includes(termo) ||
          (conta.login || "").toLowerCase().includes(termo) ||
          (conta.sigla || "").toLowerCase().includes(termo) ||
          String(conta.id).includes(termo) ||
          (termoDigitos.length >= 4 && documentoLimpo.includes(termoDigitos))
        );
      };

      const subcontasPorPrincipal = new Map();
      const principais = [];

      this.contas.forEach((conta) => {
        const temPrincipalNaLista =
          conta.contaPrincipalId && contasPorId.has(conta.contaPrincipalId);

        if (temPrincipalNaLista) {
          if (!subcontasPorPrincipal.has(conta.contaPrincipalId)) {
            subcontasPorPrincipal.set(conta.contaPrincipalId, []);
          }
          subcontasPorPrincipal.get(conta.contaPrincipalId).push(conta);
        } else {
          principais.push(conta);
        }
      });

      return (
        principais
          .map((principal) => {
            const subcontas = (subcontasPorPrincipal.get(principal.id) || [])
              .slice()
              .sort((a, b) =>
                this.nomeExibicao(a).localeCompare(this.nomeExibicao(b))
              );

            const principalCorresponde = correspondeTermo(principal);

            // Se a própria conta principal casa com a busca, mantemos todas as
            // subcontas visíveis (ex.: buscar "Meddi" não pode ocultar a
            // subconta "Multimagem"). Só filtramos subcontas quando o match veio
            // exclusivamente de uma subconta.
            const subcontasVisiveis =
              termo && !principalCorresponde
                ? subcontas.filter(correspondeTermo)
                : subcontas;

            return {
              principal,
              subcontasVisiveis,
              corresponde: principalCorresponde || subcontasVisiveis.length > 0
            };
          })
          .filter((grupo) => grupo.corresponde)
          // Grupo 2 (independentes, combinam em E — WEL-5149):
          // Principais: só oculta a lista de subcontas (ver ocultarSubcontas),
          // não remove nenhum grupo daqui — todo principal continua aparecendo.
          // Iniciantes: contas recém-cadastradas (critério de sempre) OU já
          // com indicador de fase de implantação/go-live.
          .filter(
            (grupo) =>
              !this.filtroIniciantes ||
              this.contaRecente(grupo.principal) ||
              ["IMPLANTACAO", "GO_LIVE"].includes(
                grupo.principal.indicador?.fase
              )
          )
          // Atenção (WEL-5148): qualquer motivo ativo em cin_atencao_motivos
          // (saldo em risco, sem envio recente, campanha falhando, CRM
          // parado, implantação travada, cliente não faturado).
          // O chip é tri-state: "critico" restringe ao impacto imediato,
          // "alerta" às pendências de cadastro — ver nivelAtencao().
          .filter(
            (grupo) =>
              !this.filtroAtencao ||
              this.nivelAtencao(grupo.principal) === this.filtroAtencao
          )
          // Grupo 3 (radio, só super-admin — WEL-5149, revisão do WEL-5146:
          // eram multi-select, viraram mutuamente exclusivos).
          .filter((grupo) => {
            if (!this.filtroAtividade) {
              return true;
            }

            const atividade = grupo.principal.indicador?.atividade;

            switch (this.filtroAtividade) {
              case "muito-ativas":
                return atividade === "MUITO_ATIVA";
              case "reducao-atividade":
                return atividade === "REDUCAO";
              case "quase-paradas":
                return atividade === "QUASE_PARADA";
              default:
                return false;
            }
          })
          // Grupo 4 (radio, só super-admin — WEL-5149, novo).
          .filter(
            (grupo) =>
              !this.filtroTier || grupo.principal.cliTier === this.filtroTier
          )
          // Grupo 5 (radio, só super-admin).
          .filter(
            (grupo) =>
              !this.filtroMaturidade ||
              grupo.principal.indicador?.maturidadeNivel ===
                this.filtroMaturidade
          )
          // Enquadramento comercial (WEL-5157).
          .filter(
            (grupo) =>
              !this.filtroEnquadramento ||
              grupo.principal.motivoIsencao === this.filtroEnquadramento
          )
          // Grupo 6 (radio, só super-admin — WEL-5157).
          .filter(
            (grupo) =>
              !this.filtroCrmEstagio ||
              grupo.principal.indicador?.crmEstagio === this.filtroCrmEstagio
          )
          .sort((a, b) => {
            const pesoA = a.principal.status === "A" ? 0 : 1;
            const pesoB = b.principal.status === "A" ? 0 : 1;

            if (pesoA !== pesoB) {
              return pesoA - pesoB;
            }

            return this.nomeExibicao(a.principal).localeCompare(
              this.nomeExibicao(b.principal)
            );
          })
      );
    },

    gruposContasAtivas() {
      return this.gruposContas.filter(
        (grupo) => grupo.principal.status === "A"
      );
    },

    gruposContasInativas() {
      return this.gruposContas.filter(
        (grupo) => grupo.principal.status !== "A"
      );
    },

    exibirSecaoAtivas() {
      return this.filtroStatus !== "inativas";
    },

    exibirSecaoInativas() {
      return this.filtroStatus !== "ativas";
    },

    // Contador do cabeçalho (WEL-5152): total de contas principais que
    // passaram nos filtros correntes — as subcontas não entram porque não
    // são linhas de primeiro nível da lista.
    totalContasExibidas() {
      return this.gruposContasAtivas.length + this.gruposContasInativas.length;
    },

    temFiltrosAtivos() {
      return (
        this.filtroStatus !== "ativas" ||
        this.filtroPrincipais ||
        this.filtroIniciantes ||
        this.filtroAtencao !== null ||
        this.filtroAtividade !== null ||
        this.filtroTier !== null ||
        this.filtroMaturidade !== null ||
        this.filtroEnquadramento !== null ||
        this.filtroCrmEstagio !== null
      );
    },

    // Total de contas principais carregadas, sem nenhum filtro aplicado —
    // base de comparação para saber se a lista está ou não restrita.
    totalContasCarregadas() {
      return this.contas.filter((conta) => !conta.contaPrincipalId).length;
    },

    // A lista está restrita quando há filtro de chip ativo OU busca digitada.
    listaEstaFiltrada() {
      return this.temFiltrosAtivos || this.termoBusca.trim().length > 0;
    },

    // Texto do contador no cabeçalho: "N contas totais" quando nada está
    // filtrado, "N contas filtradas" quando a lista está restrita.
    textoContadorCabecalho() {
      if (this.listaEstaFiltrada) {
        const n = this.totalContasExibidas;
        return `${n} conta${n === 1 ? "" : "s"} filtrada${n === 1 ? "" : "s"}`;
      }

      const n = this.totalContasCarregadas;
      return `${n} conta${n === 1 ? "" : "s"} ${n === 1 ? "total" : "totais"}`;
    },

    // Lista única (cabeçalhos de seção + cards) na ordem final de exibição,
    // para não duplicar o markup do card entre as seções ativas/inativas.
    itensLista() {
      const itens = [];
      const ativas = this.gruposContasAtivas;
      const inativas = this.gruposContasInativas;

      if (this.exibirSecaoAtivas && ativas.length > 0) {
        itens.push({
          tipo: "cabecalho",
          chave: "cabecalho-ativas",
          texto: "Contas ativas",
          contador: ativas.length,
          corDot: "ativa"
        });
        ativas.forEach((grupo) =>
          itens.push({
            tipo: "grupo",
            chave: `grupo-${grupo.principal.id}`,
            grupo
          })
        );
      }

      if (this.exibirSecaoInativas && inativas.length > 0) {
        itens.push({
          tipo: "cabecalho",
          chave: "cabecalho-inativas",
          texto: "Contas inativas",
          contador: inativas.length,
          corDot: "inativa"
        });
        inativas.forEach((grupo) =>
          itens.push({
            tipo: "grupo",
            chave: `grupo-${grupo.principal.id}`,
            grupo
          })
        );
      }

      return itens;
    },

    // Fatia de itensLista efetivamente renderizada — cresce em blocos
    // conforme carregarMaisItens() é acionado pelo scroll/observer.
    itensVisiveis() {
      return this.itensLista.slice(0, this.tamanhoJanela);
    },

    // Só super-admin vê o atalho de recentes; ids que não existem mais na
    // lista atual de contas (ex.: acesso revogado) são descartados aqui.
    // Durante uma busca a seção some — recentes fora do termo confundiriam.
    contasRecentesExibicao() {
      if (!this.checkSuperAdmin || this.termoBusca.trim()) {
        return [];
      }

      return this.contasRecentesIds
        .map((id) => this.mapaContas.get(String(id)))
        .filter(Boolean);
    },

    // Índice de this.contas por id (string) — evita varrer o array a cada
    // checagem pontual (ex.: riscoFaltarSaldo, contasRecentesExibicao).
    mapaContas() {
      return new Map(this.contas.map((conta) => [String(conta.id), conta]));
    }
  },

  watch: {
    // A janela de renderização incremental é sobre itensLista (recorte só de
    // exibição); ao mudar busca ou chip de status ela precisa voltar para o
    // início — senão o usuário pode "perder" itens que ficaram fora da nova
    // janela sem rolar.
    termoBusca() {
      this.resetarJanela();
    },
    filtroStatus() {
      this.resetarJanela();
    },
    filtroPrincipais() {
      this.resetarJanela();
    },
    filtroIniciantes() {
      this.resetarJanela();
    },
    filtroAtencao() {
      this.resetarJanela();
    },
    filtroAtividade() {
      this.resetarJanela();
    },
    filtroTier() {
      this.resetarJanela();
    },
    filtroMaturidade() {
      this.resetarJanela();
    },
    filtroEnquadramento() {
      this.resetarJanela();
    },
    filtroCrmEstagio() {
      this.resetarJanela();
    }
  },

  methods: {
    // Ponto de entrada público (chamado via ref pelo Header) — abre o modal
    // com a lista atual de contas disponíveis para troca.
    abrir() {
      this.resetarJanela();
      this.superAdminTrigger =
        SUPER_ADMIN_TRIGGERS[
          Math.floor(Math.random() * SUPER_ADMIN_TRIGGERS.length)
        ];
      this.$refs["mdlTrocarUsuarioOuConta"].show();

      if (this.checkSuperAdmin) {
        // Central de Contas: busca todas as contas (com indicadores) direto
        // do servidor, página a página — ver carregarContasCentral().
        this.carregarContasCentral();
        // WEL-5157: bloqueia o botão de imediato enquanto o cooldown real
        // é consultado — sem isso, o botão ficava habilitado na janela entre
        // abrir() e a resposta do carregarDisponibilidadeSincronizacao().
        this.sincronizarDisponivelEm = moment().add(5, "seconds").toISOString();
        this.carregarDisponibilidadeSincronizacao();
      } else {
        // contasParaTroca já inclui a conta atual (marcada e não clicável);
        // assim a conta atual não some e as subcontas não ficam órfãs.
        this.contas = [...this.contasParaTroca];
      }
    },

    // Busca central-contas página a página até cobrir o total informado pelo
    // servidor, achatando cada principal + suas subcontas no array plano que
    // o componente já sabe agrupar (gruposContas). Cada conta chega com seu
    // indicador (saldo, consumo, risco, etc.) — ver registrarIndicadorConta.
    // A lista é atualizada a cada página (não só ao final): a renderização
    // incremental do template já cuida do custo de DOM disso.
    async carregarContasCentral() {
      let pagina = 1;
      let total = null;
      let primeiraPaginaOk = false;
      const acumulado = [];

      try {
        do {
          const { data } = await ApiService.get(
            `central-contas?pagina=${pagina}&porPagina=${CONTAS_POR_PAGINA}`,
            "",
            false
          );
          const resultado = data.data;

          primeiraPaginaOk = true;
          total = resultado.total;

          resultado.contas.forEach((principal) => {
            acumulado.push(principal);
            (principal.subcontas || []).forEach((sub) => acumulado.push(sub));
          });

          this.contas = acumulado.slice();
          this.registrarIndicadoresIniciais(resultado.contas);

          pagina += 1;
        } while ((pagina - 1) * CONTAS_POR_PAGINA < total);
      } catch {
        if (!primeiraPaginaOk) {
          this.contas = [...this.contasParaTroca];

          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            title:
              "Não foi possível carregar a Central de Contas — exibindo lista resumida.",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
          });
        }
      }
    },

    // Preenche saldos[id] a partir do indicador de cada principal + suas
    // subcontas vindas de uma página do central-contas.
    registrarIndicadoresIniciais(principais) {
      principais.forEach((principal) => {
        this.registrarIndicadorConta(principal);
        (principal.subcontas || []).forEach((sub) =>
          this.registrarIndicadorConta(sub)
        );
      });
    },

    // Só popula saldos[id] quando o indicador já tem o limite calculado —
    // nesta etapa vários campos do indicador ainda podem vir nulos.
    registrarIndicadorConta(conta) {
      const indicador = conta.indicador;

      if (
        !indicador ||
        indicador.limite === null ||
        indicador.limite === undefined
      ) {
        return;
      }

      const credito = Number(indicador.limite) || 0;
      const saldo = Number(indicador.saldo) || 0;
      const consumo = Number(indicador.consumo) || 0;
      const percentual =
        indicador.saldoPct !== null && indicador.saldoPct !== undefined
          ? Math.min(
              100,
              Math.max(0, Math.round(100 - Number(indicador.saldoPct)))
            )
          : credito > 0
          ? Math.min(100, Math.round((consumo / credito) * 100))
          : 0;

      this.$set(this.saldos, conta.id, {
        credito,
        saldo,
        consumo,
        percentual,
        atualizadoEm: indicador.saldoAtualizadoEm || null
      });
    },

    ehContaAtual(conta) {
      return String(conta.id) === String(this.currentUserPersonalInfo.conta_id);
    },

    // Contas principais criadas há poucos dias tendem a estar em período de
    // implantação — um dos dois critérios do chip "Iniciantes" (o outro é
    // indicador.fase, ver gruposContas).
    contaRecente(conta) {
      if (!conta.dataCadastro) {
        return false;
      }

      const dataCadastro = moment(conta.dataCadastro);

      if (!dataCadastro.isValid()) {
        return false;
      }

      return moment().diff(dataCadastro, "days") <= this.diasContaRecente;
    },

    nomeExibicao(conta) {
      return conta.nome || conta.cliNome || conta.login || "";
    },

    avatarTexto(conta) {
      if (conta.sigla && conta.sigla.trim()) {
        return conta.sigla.trim().toUpperCase().slice(0, 3);
      }

      const nome = this.nomeExibicao(conta).trim();
      if (!nome) {
        return "?";
      }

      const partes = nome.split(/\s+/);
      if (partes.length === 1) {
        return partes[0].slice(0, 2).toUpperCase();
      }

      return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
    },

    documentoExibicao(conta) {
      const limpo = Utils.limparDocumento(conta.documento);

      if (!limpo) {
        return "";
      }

      if (limpo.length === 11) {
        return `CPF: ${Utils.formatarDocumento(limpo)}`;
      }

      if (limpo.length === 14) {
        return `CNPJ: ${Utils.formatarDocumento(limpo)}`;
      }

      return `Documento: ${conta.documento}`;
    },

    // Só o documento formatado (sem rótulo), para o badge compacto. O próprio
    // formato distingue CPF (11) de CNPJ (14).
    documentoNumero(conta) {
      const limpo = Utils.limparDocumento(conta.documento);

      if (!limpo) {
        return "";
      }

      return Utils.formatarDocumento(limpo) || conta.documento;
    },

    // Copia um valor (login, id ou documento) para a área de transferência,
    // com feedback via toast — facilita o dia a dia do suporte.
    copiar(valor, rotulo) {
      if (!valor) {
        return;
      }

      navigator.clipboard.writeText(String(valor)).then(() => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: `${rotulo} copiado`,
          showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true
        });
      });
    },

    copiarDocumento(conta) {
      this.copiar(Utils.limparDocumento(conta.documento), "CPF/CNPJ");
    },

    linkConexa(conta) {
      return `https://w3.conexa.app/index.php?r=vendaRecorrente/gerenciarContratos&idCliente=${conta.ctiIntegracaoId}`;
    },

    abrirLinkConexa(conta) {
      window.open(this.linkConexa(conta), "_blank", "noopener,noreferrer");
    },

    // Dropdown Faturamento (WEL-5149): status carregado sob demanda ao abrir
    // o dropdown (não entra no payload em massa da listagem) — decide se
    // mostra "Redefinir senha" (já tem acesso) ou "Liberar Área do Cliente".
    carregarStatusFaturamento(conta) {
      if (this.faturamentoStatus[conta.id]) {
        return;
      }

      this.$set(this.faturamentoStatus, conta.id, { carregando: true });

      ApiService.get(`conta/${conta.id}/faturamento/status`)
        .then((response) => {
          const dados = response.data.data || {};
          this.$set(this.faturamentoStatus, conta.id, {
            carregando: false,
            hasLoginAccess: !!dados.hasLoginAccess,
            login: dados.login || null
          });
        })
        .catch(() => {
          this.$set(this.faturamentoStatus, conta.id, {
            carregando: false,
            hasLoginAccess: false,
            erro: true
          });
        });
    },

    statusFaturamento(contaId) {
      return this.faturamentoStatus[contaId] || { carregando: true };
    },

    redefinirSenhaConexa(conta) {
      Swal.fire({
        title: `Redefinir a senha da Área do Cliente de "${this.nomeExibicao(
          conta
        )}" no Conexa?`,
        text: "Uma nova senha será gerada e exibida uma única vez, pra você repassar ao cliente.",
        showCancelButton: true,
        confirmButtonText: "Redefinir",
        cancelButtonText: "Cancelar",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-danger"
        },
        buttonsStyling: false
      }).then((result) => {
        if (!result.value) {
          return;
        }

        ApiService.post(`conta/${conta.id}/faturamento/redefinir-senha`)
          .then((response) => {
            this.mostrarCredencialGerada(response.data.data.senha);
          })
          .catch(() => {});
      });
    },

    // WEL-5157: login/senha não voltam mais crus na resposta — vão direto
    // por e-mail pros destinatários cadastrados no Conexa (fallback: usuários
    // ativos da conta no Comunicante), mesmo padrão do reenviarCobranca.
    // redefinirSenha (mostrarCredencialGerada) NÃO muda — decisão consciente.
    liberarAreaClienteConexa(conta) {
      Swal.fire({
        title: `Liberar Área do Cliente para "${this.nomeExibicao(conta)}"?`,
        text: "Login e senha serão gerados e enviados por e-mail para o cliente.",
        showCancelButton: true,
        confirmButtonText: "Liberar",
        cancelButtonText: "Cancelar",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-success"
        },
        buttonsStyling: false
      }).then((result) => {
        if (!result.value) {
          return;
        }

        ApiService.post(`conta/${conta.id}/faturamento/liberar-area-cliente`)
          .then((response) => {
            const dados = response.data.data || {};
            this.$set(this.faturamentoStatus, conta.id, {
              carregando: false,
              hasLoginAccess: true,
              login: dados.login || null
            });

            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: `Acesso liberado — e-mail enviado para ${(
                dados.destinatarios || []
              ).join(", ")}`,
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true
            });
          })
          .catch(() => {});
      });
    },

    // Reenvio de cobrança (WEL-5149/5157): busca as cobranças em aberto no
    // Conexa e decide a UI conforme a quantidade — sem cobrança não tem o
    // que reenviar, com uma só confirma direto, com várias deixa escolher.
    reenviarCobranca(conta) {
      ApiService.get(`central-contas/${conta.id}/cobrancas`)
        .then((response) => {
          const cobrancas = (response.data.data || {}).cobrancas || [];

          if (cobrancas.length === 0) {
            Swal.fire({
              icon: "info",
              title: "Nenhuma cobrança em aberto",
              text: `${this.nomeExibicao(
                conta
              )} não tem cobrança em aberto no Conexa pra reenviar.`,
              confirmButtonText: "Ok",
              customClass: { confirmButton: "btn btn-primary" },
              buttonsStyling: false
            });
            return;
          }

          if (cobrancas.length === 1) {
            this.confirmarReenvioCobranca(conta, cobrancas[0]);
            return;
          }

          const opcoes = {};
          cobrancas.forEach((cobranca) => {
            opcoes[cobranca.chargeId] = `R$ ${Number(
              cobranca.amount || 0
            ).toFixed(2)} — vencimento ${moment(cobranca.dueDate).format(
              "DD/MM/YYYY"
            )}`;
          });

          Swal.fire({
            title: `Qual cobrança de "${this.nomeExibicao(conta)}" reenviar?`,
            input: "select",
            inputOptions: opcoes,
            inputPlaceholder: "Selecione a cobrança",
            showCancelButton: true,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            customClass: {
              cancelButton: "btn btn-secondary",
              confirmButton: "btn btn-primary"
            },
            buttonsStyling: false
          }).then((result) => {
            if (!result.value) {
              return;
            }

            const cobranca = cobrancas.find(
              (c) => String(c.chargeId) === String(result.value)
            );

            if (cobranca) {
              this.confirmarReenvioCobranca(conta, cobranca);
            }
          });
        })
        .catch(() => {});
    },

    confirmarReenvioCobranca(conta, cobranca) {
      Swal.fire({
        title: `Reenviar cobrança de "${this.nomeExibicao(conta)}"?`,
        html: `Valor: <strong>R$ ${Number(cobranca.amount || 0).toFixed(
          2
        )}</strong><br>Vencimento: <strong>${moment(cobranca.dueDate).format(
          "DD/MM/YYYY"
        )}</strong><br><small class="text-muted">O e-mail será enviado com o link da fatura para os contatos cadastrados no Conexa — sem eles, para os usuários ativos da conta.</small>`,
        showCancelButton: true,
        confirmButtonText: "Enviar",
        cancelButtonText: "Cancelar",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-primary"
        },
        buttonsStyling: false
      }).then((result) => {
        if (!result.value) {
          return;
        }

        ApiService.post(`central-contas/${conta.id}/reenviar-cobranca`, {
          chargeId: cobranca.chargeId,
          chargeUrl: cobranca.chargeUrl,
          amount: cobranca.amount,
          dueDate: cobranca.dueDate
        })
          .then((response) => {
            const destinatarios =
              (response.data.data || {}).destinatarios || [];

            Swal.fire({
              icon: "success",
              title: "Cobrança reenviada",
              text: `E-mail enviado para: ${destinatarios.join(", ")}`,
              confirmButtonText: "Ok",
              customClass: { confirmButton: "btn btn-success" },
              buttonsStyling: false
            });
          })
          .catch(() => {});
      });
    },

    // Exibição única da senha gerada — nunca fica salva em lugar nenhum
    // (nem estado local, nem log/auditoria); só aparece nesse Swal.
    mostrarCredencialGerada(senha, login = null) {
      Swal.fire({
        title: "Senha gerada",
        html: `${
          login ? `<strong>Login:</strong> ${login}<br>` : ""
        }<strong>Senha:</strong> <code>${senha}</code><br><small class="text-muted">Copie agora — esta senha não será exibida novamente.</small>`,
        confirmButtonText: "Copiar e fechar",
        showCancelButton: true,
        cancelButtonText: "Fechar",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-primary"
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value && navigator.clipboard) {
          navigator.clipboard.writeText(senha);
        }
      });
    },

    // Dropdown Recursos ativos (WEL-5150): lista nomeada carregada sob
    // demanda ao abrir (a contagem já vem pronta no payload da listagem,
    // via recursosAtivosQtde — não pesa o carregamento em massa).
    carregarRecursosAtivos(conta) {
      if (this.recursosAtivos[conta.id]) {
        return;
      }

      this.$set(this.recursosAtivos, conta.id, { carregando: true, lista: [] });

      ApiService.get(`central-contas/${conta.id}/recursos`)
        .then((response) => {
          this.$set(this.recursosAtivos, conta.id, {
            carregando: false,
            lista: response.data.data.recursos || []
          });
        })
        .catch(() => {
          this.$set(this.recursosAtivos, conta.id, {
            carregando: false,
            lista: []
          });
        });
    },

    statusRecursos(contaId) {
      return this.recursosAtivos[contaId] || { carregando: true, lista: [] };
    },

    // WEL-5184/WEL-5194: abre o modal de Timeline expandida (ModalTimeline.vue
    // → Timeline.vue variant="expanded") para a conta selecionada, com busca,
    // período, paginação por cursor e painel de detalhes do evento.
    abrirModalTimeline(conta) {
      this.$refs.modalTimeline.abrir(
        conta.id,
        conta.nome || conta.conNome || ""
      );
    },

    // Cor do badge de campanhas: vermelho se todas inativas/erro 7d,
    // amarelo se CAMPANHA_FALHANDO nos motivos de atenção.
    corBadgeCampanhas(conta) {
      const qtde = conta.campanhasAtivasQtde || 0;
      if (qtde === 0) return "trocar-conta-acao-btn--campanhas-critico";
      const motivos = conta?.indicador?.atencaoMotivos || [];
      if (motivos.some((m) => m.codigo === "CAMPANHA_FALHANDO")) {
        return "trocar-conta-acao-btn--campanhas-alerta";
      }
      return "";
    },

    // Tooltip do botão Campanhas: mostra o motivo quando vermelho/amarelo.
    tooltipCampanhas(conta) {
      const qtde = conta.campanhasAtivasQtde || 0;
      if (qtde === 0) return "Nenhuma campanha ativa nos últimos 7 dias";
      const motivos = conta?.indicador?.atencaoMotivos || [];
      if (motivos.some((m) => m.codigo === "CAMPANHA_FALHANDO")) {
        return "Há falhas de campanha nos últimos 7 dias";
      }
      return "Campanhas ativas";
    },

    // WEL-5184/WEL-5197: abre o modal de Conectores (já existente em
    // ModalAgenteSistema.vue), personificado para a conta selecionada.
    abrirModalAgenteSistema(conta) {
      this.$refs.modalAgenteSistema.abrir(conta.id);
    },

    // Conteúdo HTML do popover ⓘ com os dados operacionais que saíram do card
    // (cadastro, último envio, limite). Cada linha só entra se preenchida,
    // datas em formato Brasil.
    popoverInfo(conta) {
      const linhas = [];

      if (conta.dataCadastro) {
        const data = moment(conta.dataCadastro);
        if (data.isValid()) {
          linhas.push(["Cadastro", data.format("DD/MM/YYYY")]);
        }
      }

      if (conta.dataUltimoEnvio) {
        const data = moment(conta.dataUltimoEnvio);
        if (data.isValid()) {
          linhas.push(["Último envio", data.format("DD/MM/YYYY HH:mm")]);
        }
      }

      if (conta.limiteCredito !== null && conta.limiteCredito !== undefined) {
        const limite = Number(conta.limiteCredito);
        if (!Number.isNaN(limite)) {
          const rotulo = this.checkSuperAdmin ? "Limite Disponível" : "Limite";
          linhas.push([rotulo, limite.toLocaleString("pt-BR")]);
        }
      }

      if (!linhas.length) {
        return "Sem informações adicionais.";
      }

      const corpo = linhas
        .map(
          ([rotulo, valor]) =>
            `<div class="trocar-conta-pop__linha"><span>${rotulo}</span><strong>${valor}</strong></div>`
        )
        .join("");

      return { html: true, content: corpo, title: "Detalhes da conta" };
    },

    chaveCacheSaldos() {
      return `trocarConta:saldos:${
        this.currentUserPersonalInfo.login || "anon"
      }`;
    },

    // Tooltip da barra de Limite Disponível: só existe quando saldos[id] tem
    // uma data de atualização (vem do indicador da Central de Contas ou do
    // próprio cálculo individual, para super-admin).
    // Tooltip da barra de consumo (WEL-5184): mostra consumo vs. total
    // na perspectiva nova ("X usado de Y disponível").
    tituloSaldo(idConta) {
      const dados = this.saldos[idConta];

      if (!dados || !dados.atualizadoEm) {
        return "";
      }

      const data = moment(dados.atualizadoEm);
      const consumo = dados.credito - dados.saldo;
      if (consumo <= 0) {
        return data.isValid()
          ? `Sem consumo registrado — Atualizado em ${data.format(
              "DD/MM HH:mm"
            )}`
          : "";
      }

      // Até o dia 9 a projeção mensal é instável — compara o consumo
      // atual com o limite. A partir do dia 10, projeta até o fim do mês.
      const hoje = moment();
      const dia = hoje.date();
      const projecao =
        dia >= 10 ? Math.round(consumo / (dia / hoje.daysInMonth())) : consumo;

      if (!data.isValid()) {
        return "";
      }

      const atualizado = `Atualizado em ${data.format("DD/MM HH:mm")}`;

      // Só sugere aumento quando a projeção ultrapassa o limite
      // (risco de bloqueio por falta de saldo).
      if (projecao > dados.credito) {
        const limiteSugerido = Math.ceil((projecao * 1.05) / 100) * 100;
        return `Sugerimos ajustar limite para ${limiteSugerido.toLocaleString(
          "pt-BR"
        )} (projeção mensal +5%) — ${atualizado}`;
      }

      // Limite está muito acima do consumo — sinaliza, mas não sugere
      // redução (o limite só é refinado para mais).
      if (dados.credito > 0 && projecao < dados.credito * 0.5) {
        return `Limite acima da média de consumo — ${atualizado}`;
      }

      return `Consumo dentro do esperado para o mês — ${atualizado}`;
    },

    carregarCacheSaldos() {
      try {
        const bruto = localStorage.getItem(this.chaveCacheSaldos());

        if (!bruto) {
          return;
        }

        const cache = JSON.parse(bruto);

        if (cache && cache.saldos) {
          this.saldos = cache.saldos;
          this.saldosAtualizadoEm = cache.atualizadoEm || null;
        }
      } catch {
        // Cache corrompido/indisponível: segue sem ele.
      }
    },

    salvarCacheSaldos() {
      try {
        localStorage.setItem(
          this.chaveCacheSaldos(),
          JSON.stringify({
            atualizadoEm: this.saldosAtualizadoEm,
            saldos: this.saldos
          })
        );
      } catch {
        // Sem espaço / modo privado: apenas não persiste.
      }
    },

    // Calcula o saldo/consumo desta conta sob demanda (consulta pesada não é
    // feita para todas as contas ao abrir o modal). Resultado exibido no
    // card. Para super-admin não há cache local: além de saldos[id],
    // atualiza também o indicador da conta em this.contas (o servidor já
    // persiste o snapshot, mas a UI não precisa esperar o próximo fetch).
    async carregarSaldo(idConta) {
      if (this.saldosCarregando.includes(idConta)) {
        return;
      }

      this.saldosCarregando.push(idConta);

      try {
        const { data } = await ApiService.get(`conta/saldo/${idConta}`);
        const dados = data.data;
        const credito = Number(dados.credito) || 0;
        const saldo = Number(dados.saldo) || 0;
        const consumo = Number(dados.consumo) || 0;
        const percentual =
          credito > 0
            ? Math.min(100, Math.round((consumo / credito) * 100))
            : 0;

        if (this.checkSuperAdmin) {
          const atualizadoEm = new Date().toISOString();

          this.$set(this.saldos, idConta, {
            credito,
            saldo,
            consumo,
            percentual,
            atualizadoEm
          });
          this.atualizarIndicadorLocal(idConta, {
            credito,
            saldo,
            consumo,
            percentual,
            atualizadoEm
          });
        } else {
          this.$set(this.saldos, idConta, {
            credito,
            saldo,
            consumo,
            percentual
          });
          this.salvarCacheSaldos();
        }
      } finally {
        this.saldosCarregando = this.saldosCarregando.filter(
          (id) => id !== idConta
        );
      }
    },

    // Espelha o resultado do cálculo individual no indicador da conta em
    // this.contas, para riscoFaltarSaldo/tooltip refletirem o valor fresco
    // sem esperar o próximo carregarContasCentral(). riscoSaldo não é
    // recalculado aqui (só o servidor sabe a regra) — fica como estava até a
    // próxima sincronização.
    atualizarIndicadorLocal(
      idConta,
      { credito, saldo, consumo, percentual, atualizadoEm }
    ) {
      const conta = this.mapaContas.get(String(idConta));

      if (!conta || !conta.indicador) {
        return;
      }

      conta.indicador.limite = credito;
      conta.indicador.saldo = saldo;
      conta.indicador.consumo = consumo;
      conta.indicador.saldoPct = 100 - percentual;
      conta.indicador.saldoAtualizadoEm = atualizadoEm;
    },

    // Ícone do botão de cálculo individual: super-admin vê o ícone de "envio"
    // (linguagem de Limite Disponível); demais administradores continuam com
    // o ícone de moeda de sempre. Spinner de carregamento vale para os dois.
    iconeCalculoIndividual(idConta) {
      if (this.saldosCarregando.includes(idConta)) {
        return "fas fa-spinner fa-spin";
      }

      return "fas fa-rotate";
    },

    // Dispara a sincronização em massa (job em fila no servidor) e passa a
    // acompanhar o progresso via poll, comparando cin_saldo_atualizado_em em
    // conta_indicador com o instante devolvido aqui (ver
    // CentralContaController::sincronizar — sem Cache de propósito, web e
    // worker não compartilham cache local).
    async sincronizar() {
      if (this.sincronizando) {
        return;
      }

      this.sincronizando = true;
      this.progressoSincronizacao = { atual: 0, total: 0 };
      this.pollSincronizacaoTentativas = 0;

      try {
        const { data } = await ApiService.post(
          "central-contas/sincronizar",
          {},
          null,
          false
        );
        this.acompanharSincronizacao(data.data.inicio, data.data.total, true);
      } catch (error) {
        // Bloqueia o botão IMEDIATAMENTE (cooldown de 4h), sem esperar o
        // carregarDisponibilidadeSincronizacao() terminar — eliminava a race
        // condition onde sincronizando virava false antes do estado de
        // cooldown atualizar, e o usuário clicava de novo levando outro 429.
        if (error.response?.status === 429) {
          this.sincronizarDisponivelEm = moment().add(4, "hours").toISOString();
        }
        this.sincronizando = false;
        this.carregarDisponibilidadeSincronizacao();
      }
    },

    // Estado do cooldown de 4h do botão manual (WEL-5157): busca sem
    // "desde" pra só trazer podeSincronizar/disponivelEm, sem depender de
    // um clique anterior. Chamado ao abrir a Central e de novo ao final de
    // uma sincronização (o cooldown reinicia).
    async carregarDisponibilidadeSincronizacao() {
      try {
        const { data } = await ApiService.get(
          "central-contas/sincronizacao",
          "",
          false
        );
        this.sincronizarDisponivelEm = data.data.podeSincronizar
          ? null
          : data.data.disponivelEm;
      } catch {
        // Falha aqui não é crítica — o botão só fica sem o estado
        // "desabilitado preventivo"; o clique ainda funciona normalmente
        // (ou mostra o 429, agora que o interceptor trata esse status).
      }
    },

    // Consulta central-contas/sincronizacao a cada INTERVALO_POLL_SINCRONIZACAO
    // enquanto o job estiver executando. `sabiaQueIniciou` só é true quando
    // este clique efetivamente disparou o job — é o que decide se mostramos
    // o toast de conclusão e recarregamos a lista.
    async acompanharSincronizacao(desde, totalEsperado, sabiaQueIniciou) {
      let progresso;

      try {
        const { data } = await ApiService.get(
          `central-contas/sincronizacao?desde=${encodeURIComponent(desde)}`,
          "",
          false
        );
        progresso = data.data;
      } catch {
        this.sincronizando = false;
        return;
      }

      this.progressoSincronizacao = {
        atual: progresso.atual || 0,
        total: progresso.total || totalEsperado || 0
      };

      this.pollSincronizacaoTentativas++;

      const executando =
        !!progresso.executando &&
        this.pollSincronizacaoTentativas < POLLS_MAXIMOS_SINCRONIZACAO;

      if (executando) {
        this.pollSincronizacao = setTimeout(
          () => this.acompanharSincronizacao(desde, totalEsperado, true),
          INTERVALO_POLL_SINCRONIZACAO
        );
        return;
      }

      this.sincronizando = false;
      this.carregarDisponibilidadeSincronizacao();

      if (!sabiaQueIniciou) {
        return;
      }

      await this.carregarContasCentral();

      const incompleta =
        this.progressoSincronizacao.atual < this.progressoSincronizacao.total;

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: incompleta ? "warning" : "success",
        title: incompleta
          ? "Sincronização ainda em andamento no servidor — os dados serão atualizados aos poucos"
          : "Contas sincronizadas!",
        showConfirmButton: false,
        timer: incompleta ? 4000 : 2000,
        timerProgressBar: true
      });
    },

    pararPollSincronizacao() {
      if (this.pollSincronizacao) {
        clearTimeout(this.pollSincronizacao);
        this.pollSincronizacao = null;
      }
    },

    // Compara o ritmo de consumo com o ritmo do calendário: se já foi
    // consumida uma fração do saldo maior que a fração do mês já
    // transcorrida (ex.: dia 13 de um mês de 30 dias = 43% do mês, mas mais
    // de 50% do saldo já consumido), a tendência é faltar antes do fim do
    // ciclo mensal. Fallback usado quando o indicador da Central de Contas
    // ainda não existe para a conta (ex.: caiu no fallback de contasParaTroca
    // ou o cálculo veio só do botão individual, para não super-admin).
    riscoFaltarSaldo(idConta) {
      if (this.checkSuperAdmin) {
        const conta = this.mapaContas.get(String(idConta));

        if (conta && conta.indicador) {
          return (
            conta.indicador.riscoSaldo !== null &&
            conta.indicador.riscoSaldo !== undefined
          );
        }
      }

      const dados = this.saldos[idConta];

      if (!dados) {
        return false;
      }

      const hoje = moment();
      const fracaoMes = hoje.date() / hoje.daysInMonth();
      const fracaoConsumida = dados.percentual / 100;

      return fracaoConsumida > fracaoMes;
    },

    // WEL-5184: percentual de consumo (0%→100%) — perspectiva invertida,
    // mostra quanto já FOI USADO em vez de quanto ainda resta.
    percentualConsumo(idConta) {
      const dados = this.saldos[idConta];

      if (!dados) {
        return 0;
      }

      return Math.max(0, Math.min(100, dados.percentual));
    },

    // Mantido por compatibilidade (tooltip, etc.) — ainda representa o
    // disponível, só não é mais usado na barra/número principal.
    percentualDisponivel(idConta) {
      const dados = this.saldos[idConta];

      if (!dados) {
        return 0;
      }

      return Math.max(0, Math.min(100, 100 - dados.percentual));
    },

    // Cor da barra de consumo (WEL-5184): inverteu de disponível para
    // consumo — quanto MAIS consumiu, pior. >= 85% crítico, >= 60% alerta.
    saldoCorClasse(idConta) {
      const consumo = this.percentualConsumo(idConta);

      if (!this.saldos[idConta]) {
        return "";
      }

      if (consumo >= 85) {
        return "trocar-conta-saldo--critico";
      }

      if (consumo >= 60) {
        return "trocar-conta-saldo--alerta";
      }

      return "";
    },

    chaveCacheRecentes() {
      return `trocarConta:recentes:${
        this.currentUserPersonalInfo.login || "anon"
      }`;
    },

    carregarRecentes() {
      try {
        const bruto = localStorage.getItem(this.chaveCacheRecentes());

        if (!bruto) {
          return;
        }

        const lista = JSON.parse(bruto);

        if (Array.isArray(lista)) {
          this.contasRecentesIds = lista;
        }
      } catch {
        // Cache corrompido/indisponível: segue sem ele.
      }
    },

    salvarRecentes() {
      try {
        localStorage.setItem(
          this.chaveCacheRecentes(),
          JSON.stringify(this.contasRecentesIds)
        );
      } catch {
        // Sem espaço / modo privado: apenas não persiste.
      }
    },

    // Chamado a cada troca efetivada (ver trocarConta) — mantém a conta mais
    // recente no topo e limita a MAX_CONTAS_RECENTES.
    registrarAcessoRecente(idConta) {
      const id = String(idConta);

      this.contasRecentesIds = [
        id,
        ...this.contasRecentesIds.filter((existente) => existente !== id)
      ].slice(0, MAX_CONTAS_RECENTES);

      this.salvarRecentes();
    },

    limparRecentes() {
      this.contasRecentesIds = [];
      this.salvarRecentes();
    },

    acaoConfiguracao(conta) {
      this.abrirConfiguracao(conta);
    },

    acaoUsuarios(conta) {
      this.contaAcao = conta;
      this.$nextTick(() => this.$refs.modalUsuarios.abrir());
    },

    acaoCadastrar(conta) {
      this.contaAcao = conta;
      this.$nextTick(() => this.$refs.modalCadastrar.abrir());
    },

    acaoEnviarManual(conta) {
      this.contaAcao = conta;
      this.$nextTick(() => this.$refs.modalEnviarManual.abrir());
    },

    acaoAlterarSenha(conta) {
      this.contaAcao = conta;
      this.$nextTick(() => this.$refs.modalAlterarSenha.abrir());
    },

    contaCadastrada() {
      Swal.fire({
        icon: "success",
        title: "Subconta cadastrada!",
        text: "Ela aparecerá na lista após atualizar a sessão.",
        timer: 2500,
        showConfirmButton: false
      });
    },

    // Bloquear/Desbloquear reusando o mesmo endpoint da tela Contas
    // (GET conta/status/{bloquear|desbloquear}/{id}).
    alterarStatusConta(conta) {
      const bloquear = conta.status === "A";
      const rota = bloquear ? "bloquear" : "desbloquear";

      Swal.fire({
        title: `Deseja realmente ${rota} a conta "${this.nomeExibicao(
          conta
        )}"?`,
        showCancelButton: true,
        confirmButtonText: bloquear ? "Bloquear" : "Desbloquear",
        cancelButtonText: "Cancelar",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: bloquear ? "btn btn-danger" : "btn btn-success"
        },
        buttonsStyling: false
      }).then((result) => {
        if (!result.value) {
          return;
        }

        ApiService.get(`conta/status/${rota}/${conta.id}`)
          .then((response) => {
            const atualizada = response.data.data;
            conta.status =
              atualizada && atualizada.status
                ? atualizada.status
                : bloquear
                ? "B"
                : "A";

            Swal.fire({
              icon: "success",
              title: `Conta ${bloquear ? "bloqueada" : "desbloqueada"}!`,
              timer: 2000,
              showConfirmButton: false
            });
          })
          .catch(() => {});
      });
    },

    statusInfo(status) {
      return STATUS_INFO[status] || STATUS_INFO.B;
    },

    // Ícone + tooltip do indicador de Atividade exibido ao lado do dot de
    // status. Só faz sentido para contas principais (indicador é do grupo);
    // retorna null quando não há atividade calculada (subconta ou conta sem
    // base histórica suficiente ainda) — o ícone simplesmente não aparece.
    atividadeInfo(conta) {
      const indicador = conta.indicador;

      if (!indicador || !ATIVIDADE_INFO[indicador.atividade]) {
        return null;
      }

      const base = ATIVIDADE_INFO[indicador.atividade];
      const pct =
        indicador.atividadePct !== null && indicador.atividadePct !== undefined
          ? Math.round(Number(indicador.atividadePct))
          : null;

      return {
        icone: base.icone,
        cor: base.cor,
        rotulo: base.rotulo,
        titulo: pct !== null ? `${base.texto} (${pct}% da média)` : base.texto
      };
    },

    // Tooltip do indicador de Fase (ícone fa-rocket). Em GO_LIVE inclui a
    // data do primeiro envio quando disponível; retorna null quando a conta
    // já é madura (ou ainda não tem indicador) — mesmo comportamento de
    // atividadeInfo quanto a subcontas/super-admin.
    faseInfo(conta) {
      const indicador = conta.indicador;

      if (!indicador) {
        return null;
      }

      // WEL-5172/5157: CRM estágio mescla com Fase — se a conta tem
      // estágio no Atendare mas cin_fase é nulo, mostra o texto do CRM
      // como se fosse a Fase da conta (ex.: "Integração", "Finalizado").
      // Se tem os dois, o CRM aparece como sufixo no tooltip.
      if (!FASE_INFO[indicador.fase] && !indicador.crmEstagio) {
        return null;
      }

      let rotulo, titulo, icone;

      if (FASE_INFO[indicador.fase]) {
        const base = FASE_INFO[indicador.fase];
        rotulo = base.rotulo;
        titulo = base.texto;
        icone = "fas fa-rocket";
      } else {
        // Só CRM, sem cin_fase — usa o ícone e o texto do estágio
        rotulo = indicador.crmEstagio;
        titulo = `CRM: ${indicador.crmEstagio}`;
        icone = "fas fa-bars-progress";
      }

      // Data da última atualização do CRM (WEL-5157): útil pra saber há
      // quanto tempo o estágio está parado sem precisar abrir o Atendare.
      const dataCrm = indicador.crmProjetoAtualizado
        ? moment(indicador.crmProjetoAtualizado).isValid()
          ? ` (${moment(indicador.crmProjetoAtualizado).format("DD/MM")})`
          : ""
        : "";

      const sufixoCrm =
        indicador.crmEstagio && rotulo !== indicador.crmEstagio
          ? ` — CRM: ${indicador.crmEstagio}${dataCrm}`
          : indicador.crmEstagio
          ? ` — atualizado ${dataCrm}`
          : "";

      if (indicador.fase === "GO_LIVE" && indicador.primeiroEnvio) {
        const data = moment(indicador.primeiroEnvio);

        if (data.isValid()) {
          return {
            rotulo,
            titulo: `${titulo} (${data.format("DD/MM/YYYY")})${sufixoCrm}`,
            icone
          };
        }
      }

      return { rotulo, titulo: `${titulo}${sufixoCrm}`, icone };
    },

    // Ícone de Tier do cliente (estrela) ao lado dos indicadores de atividade
    // e fase. Tier é atributo do cliente (cli_tier), não do indicador — vem
    // como cliTier no objeto da conta. Só super-admin vê.
    tierInfo(conta) {
      if (!conta) {
        return null;
      }

      const tier = conta.cliTier;

      if (!tier || !TIER_INFO[tier]) {
        return null;
      }

      const base = TIER_INFO[tier];

      return {
        icone: base.icone,
        rotulo: base.rotulo,
        titulo: base.titulo,
        nivel: `t${tier}`
      };
    },

    // Ícone de Maturidade (WEL-5147): combina engajamento (ranking Conexão
    // Única) com porte (faturamento 6M + recursos). Só super-admin, só
    // principais — segue o mesmo padrão de atividadeInfo/faseInfo/tierInfo.
    maturidadeInfo(conta) {
      if (!conta) {
        return null;
      }

      const nivel = conta.indicador?.maturidadeNivel;

      if (!nivel || !MATURIDADE_INFO[nivel]) {
        return null;
      }

      const base = MATURIDADE_INFO[nivel];

      return {
        icone: base.icone,
        rotulo: base.rotulo,
        titulo: base.titulo,
        nivel: `m${nivel}`
      };
    },

    // Enquadramento comercial (WEL-5157): só relevante quando a conta não
    // fatura (con_faturar <> 'S') — mesma regra de SEM_MOTIVO_ISENCAO no
    // backend. Não gated por checkSuperAdmin: é informação de cadastro, não
    // um indicador operacional restrito como Tier/Maturidade/Fase/Atenção.
    enquadramentoInfo(conta) {
      if (!conta || conta.faturar === "S") {
        return null;
      }

      const base = ENQUADRAMENTO_INFO[conta.motivoIsencao];

      return base
        ? {
            icone: base.icone,
            titulo: base.titulo,
            codigo: conta.motivoIsencao
          }
        : null;
    },

    // Ícone de Atenção (WEL-5148): consolida saldo em risco, sem envio
    // recente, campanha falhando, CRM parado e implantação travada num
    // único sinal. Retorna null quando não há nenhum motivo ativo — mesmo
    // padrão de tierInfo/maturidadeInfo (ícone só aparece se houver dado).
    atencaoInfo(conta) {
      if (!conta) {
        return null;
      }

      const motivos = conta.indicador?.atencaoMotivos || [];

      if (motivos.length === 0) {
        return null;
      }

      const titulo = motivos
        .map((motivo) => ATENCAO_LABELS[motivo.codigo] || motivo.codigo)
        .join(" • ");

      return { motivos, titulo };
    },

    // Cobrança vencida (WEL-5150): reaproveita o motivo de Atenção
    // CONEXA_INADIMPLENTE já calculado (cobrança vencida em aberto no
    // Conexa) para o alerta no ícone de Faturamento — sem chamada extra.
    // Rótulo deliberadamente vago (WEL-5157, pedido do Marcel): o tooltip
    // diz "pendência administrativa", não "cobrança vencida" — não expor
    // ao suporte, em termo explícito, que a situação do cliente envolve
    // dinheiro. O ícone já sinaliza que precisa de atenção; a natureza
    // exata fica só pra quem abre o Conexa de verdade.
    contaInadimplente(conta) {
      const motivos = conta?.indicador?.atencaoMotivos || [];

      return motivos.some((motivo) => motivo.codigo === "CONEXA_INADIMPLENTE");
    },

    // Nível da faixa lateral (WEL-5152): os motivos são exatamente os mesmos
    // do ícone de Atenção — o que muda é a leitura de prioridade para quem
    // varre a lista.
    //
    //   vermelho   — impacto operacional ou financeiro acontecendo agora.
    //   âmbar      — monitoramento / risco se aproximando.
    //   azul       — cadastro/configuração por regularizar.
    nivelAtencao(conta) {
      const motivos = conta?.indicador?.atencaoMotivos || [];

      if (motivos.length === 0) {
        return null;
      }

      const impactoImediato = [
        "SEM_ENVIO_RECENTE",
        "CAMPANHA_FALHANDO",
        "CONEXA_INADIMPLENTE",
        "CLIENTE_NAO_FATURADO"
      ];

      const administrativo = [
        "CRM_PARADO",
        "SEM_MOTIVO_ISENCAO",
        "FATURAMENTO_SEM_INTEGRACAO_CONEXA"
      ];

      const temCritico = motivos.some((motivo) => {
        if (impactoImediato.includes(motivo.codigo)) {
          return true;
        }
        return (
          motivo.codigo === "SALDO_RISCO" &&
          (motivo.dados || {}).risco === "CRITICO"
        );
      });

      const temAdministrativo = motivos.some((motivo) =>
        administrativo.includes(motivo.codigo)
      );

      // Um mesmo grupo pode ter motivos de níveis diferentes — a ordem de
      // prioridade é: crítico > alerta > pendência (administrativo).
      if (temCritico) return "critico";
      if (temAdministrativo) return "pendencia";
      return "alerta";
    },

    subcontasParaExibir(grupo) {
      if (this.termoBusca.trim()) {
        return grupo.subcontasVisiveis;
      }

      if (this.subcontasExpandidas.includes(grupo.principal.id)) {
        return grupo.subcontasVisiveis;
      }

      return grupo.subcontasVisiveis.slice(0, this.limiteSubcontasPadrao);
    },

    expandirTodasSubcontas(idPrincipal) {
      if (!this.subcontasExpandidas.includes(idPrincipal)) {
        this.subcontasExpandidas.push(idPrincipal);
      }
    },

    alternarExpandirPrincipal(idPrincipal) {
      const indice = this.principaisExpandidos.indexOf(idPrincipal);
      if (indice === -1) {
        this.principaisExpandidos.push(idPrincipal);
      } else {
        this.principaisExpandidos.splice(indice, 1);
      }
    },

    grupoEstaExpandido(grupo) {
      if (this.termoBusca.trim() && grupo.subcontasVisiveis.length > 0) {
        return true;
      }

      return this.principaisExpandidos.includes(grupo.principal.id);
    },

    debounce(filtro) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.termoBusca = filtro;
        this.removeSelected();
      }, 300);
    },

    // Grupo 3, radio (WEL-5149): clicar no chip já ativo limpa o filtro;
    // clicar em outro troca. Nunca fica mais de um valor deste grupo ativo.
    toggleFiltroAtividade(valor) {
      this.filtroAtividade = this.filtroAtividade === valor ? null : valor;
    },

    // Grupo 4, radio (WEL-5149): mesma regra de clique-de-novo-limpa.
    toggleTier(valor) {
      this.filtroTier = this.filtroTier === valor ? null : valor;
    },

    // Grupo 5, radio (WEL-5150): mesma regra de clique-de-novo-limpa.
    toggleMaturidade(valor) {
      this.filtroMaturidade = this.filtroMaturidade === valor ? null : valor;
    },

    // Enquadramento comercial (WEL-5157): ciclo único Pacote(R) →
    // Parceria(P) → Isento(I) → limpa. Mesmo padrão do chip Atenção.
    ciclarEnquadramento() {
      const ciclo = ["R", "P", "I"];
      const idx = ciclo.indexOf(this.filtroEnquadramento);
      this.filtroEnquadramento =
        idx === ciclo.length - 1 ? null : ciclo[idx + 1];
    },

    toggleCrmEstagio(valor) {
      // null = click no chip principal, alterna o dropdown
      if (valor === null) {
        this.crmDropdownAberto = !this.crmDropdownAberto;
        return;
      }
      this.filtroCrmEstagio = this.filtroCrmEstagio === valor ? null : valor;
      this.crmDropdownAberto = false;
    },

    // Grupo 2, toggles independentes (WEL-5149): cada chip liga/desliga o
    // próprio flag, sem afetar os demais — combinam livremente entre si e
    // com qualquer outro grupo.
    toggleCategoria(chave) {
      const chip = this.chipsFiltroCategoria.find((c) => c.chave === chave);

      // Chips com níveis (Atenção) percorrem os valores em ciclo e voltam a
      // null; os demais continuam sendo toggle booleano simples.
      if (chip && chip.niveis) {
        const valores = chip.niveis.map((n) => n.valor);
        const indice = valores.indexOf(this[chave]);
        this[chave] =
          indice === valores.length - 1 ? null : valores[indice + 1];
        return;
      }

      this[chave] = !this[chave];
    },

    // Método (não `this[chave]` direto no template) — dentro de um v-for, o
    // Vue 2 compila a expressão numa função comum, onde `this` não é a
    // instância do componente (causava "Cannot read properties of
    // undefined" em produção). Métodos são bindados corretamente pelo Vue.
    categoriaAtiva(chave) {
      return !!this[chave];
    },

    // Nível atualmente selecionado de um chip com níveis (Atenção), ou null
    // quando o chip está desligado / não tem níveis.
    nivelCategoria(chip) {
      if (!chip.niveis) {
        return null;
      }

      return chip.niveis.find((n) => n.valor === this[chip.chave]) || null;
    },

    textoCategoria(chip) {
      const nivel = this.nivelCategoria(chip);

      return nivel ? nivel.texto : chip.texto;
    },

    corCategoria(chip) {
      const nivel = this.nivelCategoria(chip);

      return nivel ? nivel.cor : chip.cor;
    },

    tituloCategoria(chip) {
      if (!chip.niveis) {
        return null;
      }

      const nivel = this.nivelCategoria(chip);

      if (!nivel) {
        return "Clique para filtrar por nível de atenção";
      }

      if (nivel.valor === "critico") {
        return "Crítico: impacto imediato (envio parado, campanha falhando, cobrança vencida, saldo crítico) — clique para ver monitoramento";
      }

      if (nivel.valor === "alerta") {
        return "Alerta: monitoramento (saldo em observação, implantação sem deslanchar) — clique para ver pendências administrativas";
      }

      return "Pendência: cadastro/configuração por regularizar (CRM parado, motivo de isenção, Conexa) — clique para limpar";
    },

    // Chips com alterna: toggle entre o valor principal e o alternativo.
    // Ex.: chip "Ativas" alterna para "Inativas" quando clicado de novo.
    toggleChip(chip) {
      if (chip.alterna) {
        if (this.filtroStatus === chip.valor) {
          this.filtroStatus = chip.alterna;
        } else if (this.filtroStatus === chip.alterna) {
          this.filtroStatus = chip.valor;
        } else {
          this.filtroStatus = chip.valor;
        }
      } else {
        this.filtroStatus = chip.valor;
      }
    },

    limparBusca() {
      clearTimeout(this.debounceTimeout);
      this.filtroContas = "";
      this.termoBusca = "";
      this.removeSelected();
      this.$nextTick(() => {
        const input = this.$refs.inputBusca;
        if (input && input.$el) {
          input.$el.focus();
        }
      });
    },

    limparFiltros() {
      this.filtroStatus = "ativas";
      this.filtroPrincipais = false;
      this.filtroIniciantes = false;
      this.filtroAtencao = null;
      this.filtroAtividade = null;
      this.filtroTier = null;
      this.filtroMaturidade = null;
      this.filtroEnquadramento = null;
      this.filtroCrmEstagio = null;
    },

    limpar() {
      this.idContaSelecionada = null;
      this.contas = [];
      this.filtroContas = "";
      this.termoBusca = "";
      this.filtroStatus = "ativas";
      this.filtroPrincipais = false;
      this.filtroIniciantes = false;
      this.filtroAtencao = null;
      this.filtroAtividade = null;
      this.filtroTier = null;
      this.filtroMaturidade = null;
      this.filtroEnquadramento = null;
      this.filtroCrmEstagio = null;
      this.principaisExpandidos = [];
      this.subcontasExpandidas = [];
      this.resetarJanela();
      this.pararObservadorLista();
      this.pararPollSincronizacao();
      this.sincronizando = false;
      this.progressoSincronizacao = { atual: 0, total: 0 };
    },

    // Exibe a engrenagem de configuração apenas nas contas que o usuário
    // realmente pode configurar — evita mostrar o botão e cair em "Não
    // autorizado". Espelha o backend Usuario::podeConfigurarConta: super-admin
    // (mesmo personificando) acessa qualquer conta; demais administradores,
    // apenas a própria conta ou suas subcontas (exige permissão gerenciar-conta).
    podeConfigurarConta(conta) {
      if (this.checkSuperAdmin) {
        return true;
      }

      if (!this.hasPermission("gerenciar-conta")) {
        return false;
      }

      const minhaContaId = String(this.currentUserPersonalInfo.conta_id);

      return (
        String(conta.id) === minhaContaId ||
        String(conta.contaPrincipalId) === minhaContaId
      );
    },

    // "Usuários" usa uma permissão diferente de "Configuração": o backend
    // (ContaController::obterUsuarios) só exige posse da conta (mesma regra
    // de podeConfigurarConta) e a permissão Spatie 'listar-usuario' — nunca
    // 'gerenciar-conta'. Mesmo padrão já usado em GerenciarConta.vue
    // ("menu > contas": isAdmin || hasPermission('listar-usuario')).
    podeVerUsuarios(conta) {
      if (this.checkSuperAdmin) {
        return true;
      }

      if (!this.hasPermission("listar-usuario")) {
        return false;
      }

      const minhaContaId = String(this.currentUserPersonalInfo.conta_id);

      return (
        String(conta.id) === minhaContaId ||
        String(conta.contaPrincipalId) === minhaContaId
      );
    },

    // Abre o mesmo modal de Configuração usado na tela de Contas, sem sair da
    // troca de conta. Busca sob demanda apenas os campos de plano que o modal
    // consome direto (Opção A) — os demais dados vêm da própria linha e as
    // abas restantes se auto-carregam por conta.id.
    async abrirConfiguracao(conta) {
      const { data } = await ApiService.get(`conta/dados-plano/${conta.id}`);
      const dadosPlano = data.data;

      this.contaConfig = {
        id: conta.id,
        login: conta.login,
        nome: this.nomeExibicao(conta),
        sigla: conta.sigla,
        contaPrincipal: conta.contaPrincipalId || null,
        tipoPlano: dadosPlano.tipoPlano,
        limiteCredito: dadosPlano.limiteCredito,
        permitirMensagensLongas: dadosPlano.permitirMensagensLongas,
        // Só é gravado pelo backend quando quem salva é super-admin (ver
        // tab-plano); para os demais o campo não aparece no formulário.
        checaEnvio: dadosPlano.checaEnvio,
        // Tier e CRM (WEL-5146): classificação do cliente e vínculo Atendare.
        // Só super-admin edita — os demais recebem null e o campo não aparece.
        tier: dadosPlano.tier,
        crmId: dadosPlano.crmId
      };
      this.exibirAbasConfig = !conta.contaPrincipalId;

      this.$nextTick(() => {
        this.$refs.modalConfiguracao.abrir();
      });
    },

    trocarConta(conta) {
      // Não troca para a conta já ativa (ela aparece na lista apenas como
      // referência/agrupamento das subcontas).
      if (String(conta) === String(this.currentUserPersonalInfo.conta_id)) {
        return;
      }

      Swal.fire({
        title: "Deseja realmente trocar para a conta selecionada?",
        showCancelButton: true,
        confirmButtonText: "Trocar",
        cancelButtonText: "Cancelar",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-success"
        },
        buttonsStyling: false
      }).then((result) => {
        if (!result.value) {
          return;
        }

        // A troca em si é rápida, mas o reload completo da página (+
        // verificar-login) que vem depois tem um instante de tela em branco.
        // Esse overlay preenche o intervalo entre o clique e o reload, para
        // não parecer que a ação travou.
        Swal.fire({
          title: "Trocando de conta...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        ApiService.post("/usuario/trocar-conta", {
          contaId: conta
        })
          .then(() => {
            this.registrarAcessoRecente(conta);
            localStorage.removeItem(
              "filtrosCampanha-" + this.currentUserPersonalInfo.login
            );
            window.location.href = "/";
          })
          .catch(() => {
            Swal.close();
          });
      });
    },

    trocarParaSuperAdmin() {
      // WEL-5175: a cada 3ª troca, questiona o motivo antes do confirm
      // padrão — não impede o uso, só coleta contexto do que ainda falta
      // migrar pro painel comum.
      if (this.deveQuestionarSuperAdmin) {
        this.questionarMotivoSuperAdmin();
        return;
      }

      Swal.fire({
        title:
          "Deseja realmente trocar o usuário para Administrador do Sistema?",
        showCancelButton: true,
        confirmButtonText: "Trocar",
        cancelButtonText: "Cancelar",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-info"
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          this.efetivarTrocaSuperAdmin("");
        }
      });
    },

    questionarMotivoSuperAdmin() {
      Swal.fire({
        title: `Precisa mesmo "${
          this.superAdminTrigger ? this.superAdminTrigger.text : "trocar"
        }"?`,
        html: "Conta pra gente o que você não encontrou fora do modo Administrador do Sistema — ajuda a priorizar o que falta migrar pro painel comum.",
        input: "textarea",
        inputPlaceholder: "O que você precisava fazer? (opcional)",
        showCancelButton: true,
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-info"
        },
        buttonsStyling: false
      }).then((result) => {
        // Campo é opcional — texto vazio + confirmar precisa efetivar a
        // troca do mesmo jeito, então checa isConfirmed (não !result.value,
        // que trataria "" como cancelamento).
        if (result.isConfirmed) {
          this.efetivarTrocaSuperAdmin(result.value || "");
        }
      });
    },

    efetivarTrocaSuperAdmin(motivo) {
      ApiService.post("/usuario/trocar-para-super-admin", { motivo }).then(
        () => {
          window.location.href = "/";
        }
      );
    },

    obterIdContaSelecionada(obj) {
      this.idContaSelecionada = obj ? obj.id : null;
    },

    obterLinhasNavegaveis() {
      if (!this.$refs.lista) {
        return [];
      }

      return Array.from(this.$refs.lista.querySelectorAll(".linha-navegavel"));
    },

    focusFirstItem() {
      const linhas = this.obterLinhasNavegaveis();
      if (linhas[0]) {
        linhas[0].classList.add("selecionado");
      }
    },

    handleKeyUpDown(event) {
      const linhas = this.obterLinhasNavegaveis();
      const atual = linhas.findIndex((el) =>
        el.classList.contains("selecionado")
      );

      if (atual === -1) {
        this.focusFirstItem();
        return;
      }

      if (event.key === "ArrowDown" && atual < linhas.length - 1) {
        linhas[atual].classList.remove("selecionado");
        linhas[atual + 1].classList.add("selecionado");
      } else if (event.key === "ArrowUp" && atual > 0) {
        linhas[atual].classList.remove("selecionado");
        linhas[atual - 1].classList.add("selecionado");
      }
    },

    changeSelected() {
      const ativa = this.obterLinhasNavegaveis().find((el) =>
        el.classList.contains("selecionado")
      );

      if (ativa) {
        this.trocarConta(ativa.getAttribute("data-conta-id"));
      }
    },

    removeSelected() {
      const ativa = this.obterLinhasNavegaveis().find((el) =>
        el.classList.contains("selecionado")
      );
      ativa?.classList.remove("selecionado");
    },

    resetarJanela() {
      this.tamanhoJanela = TAMANHO_INICIAL_LISTA;
    },

    carregarMaisItens() {
      if (this.tamanhoJanela >= this.itensLista.length) {
        return;
      }

      this.tamanhoJanela = Math.min(
        this.tamanhoJanela + BLOCO_LISTA,
        this.itensLista.length
      );

      // Depois de expandir a janela, a sentinela pode continuar visível —
      // sem isso o IntersectionObserver não re-dispara porque o elemento
      // nunca saiu do viewport. Re-observar no próximo tick resolve.
      this.$nextTick(() => {
        if (this.observadorLista && this.$refs.sentinelaLista) {
          this.observadorLista.unobserve(this.$refs.sentinelaLista);
          this.observadorLista.observe(this.$refs.sentinelaLista);
        }
      });
    },

    // Observa a sentinela no fim da lista renderizada para acionar o próximo
    // bloco (ver comentário da sentinela no template). O bootstrap-vue não
    // teleporta o b-modal para fora da árvore do componente, então dá para
    // localizar o container de rolagem (.modal-body, via a classe do prop
    // body-class) direto no document.
    iniciarObservadorLista() {
      this.pararObservadorLista();

      const sentinela = this.$refs.sentinelaLista;
      if (!sentinela) {
        return;
      }

      const container = document.querySelector(".trocar-conta-modal-body");

      if (typeof IntersectionObserver === "undefined") {
        // Fallback sem dependência nova: mede a distância até o fim do
        // scroll diretamente no container do modal.
        if (container) {
          this.scrollFallbackContainer = container;
          this.scrollFallbackHandler = () => this.verificarScrollFallback();
          container.addEventListener("scroll", this.scrollFallbackHandler);
        }
        return;
      }

      this.observadorLista = new IntersectionObserver(
        (entradas) => {
          if (entradas.some((entrada) => entrada.isIntersecting)) {
            this.carregarMaisItens();
          }
        },
        { root: container || null, rootMargin: "200px" }
      );
      this.observadorLista.observe(sentinela);
    },

    pararObservadorLista() {
      if (this.observadorLista) {
        this.observadorLista.disconnect();
        this.observadorLista = null;
      }

      if (this.scrollFallbackContainer && this.scrollFallbackHandler) {
        this.scrollFallbackContainer.removeEventListener(
          "scroll",
          this.scrollFallbackHandler
        );
      }

      this.scrollFallbackContainer = null;
      this.scrollFallbackHandler = null;
    },

    verificarScrollFallback() {
      const el = this.scrollFallbackContainer;
      if (!el) {
        return;
      }

      const proximoDoFim =
        el.scrollHeight - el.scrollTop - el.clientHeight < 200;

      if (proximoDoFim) {
        this.carregarMaisItens();
      }
    }
  }
};
</script>

<style lang="scss">
$trocar-conta-purple: #472282;

.trocar-conta-modal-content {
  border: 1px solid #eeecf3;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(31, 20, 60, 0.15);
  overflow: hidden;

  // Bootstrap 4 renderiza tooltips como .tooltip no <body>, não dentro do
  // modal — este seletor não alcança eles. Mas os popovers (v-b-popover)
  // podem ser renderizados como filhos, e tooltips que escapam para o body
  // precisam de um override global (ver .trocar-conta-tooltip abaixo).
}

.trocar-conta-modal-header {
  padding: 1.15rem 1.5rem;
  border-bottom: 1px solid #f2f1f6 !important;

  .modal-title {
    font-weight: 700;
    color: #2b2640;
  }

  .close {
    color: #2b2640;
    text-shadow: none;
    outline: none;

    &:hover {
      color: $trocar-conta-purple;
    }
  }
}

.trocar-conta-modal-header__conteudo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
}

.trocar-conta-modal-header__identidade {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.trocar-conta-modal-header__titulo {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #2b2640;
  line-height: 1.3;
}

// Contador de contas (WEL-5152): subiu do corpo para o cabeçalho, junto do
// título — os contadores por seção (ativas/inativas) continuam existindo.
.trocar-conta-modal-header__contador {
  font-size: 0.78rem;
  font-weight: 500;
  color: #a0a4b2;
  line-height: 1.4;
}

.trocar-conta-modal-header__acoes {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 0 0 auto;

  // "Novo Cliente" usa .btn-sm do Bootstrap (0.875rem) — normalizar para a
  // mesma altura/raio dos demais botões do cabeçalho.
  .btn-sm {
    height: 36px;
    font-size: 0.88rem;
    border-radius: 8px;
    padding: 0 0.85rem;
  }
}

.trocar-conta-modal-header__fechar {
  margin: 0 0 0 0.15rem;
  padding: 0 0.35rem;
  font-size: 1.5rem;
  line-height: 1;
  opacity: 0.55;

  &:hover {
    opacity: 1;
  }
}

// Botões do cabeçalho (Sincronizar / seletor de contexto): mesmo tamanho e
// raio do resto do modal — antes usavam .btn-sm do Bootstrap, que destoava
// da altura dos chips de filtro logo abaixo.
.trocar-conta-btn-header {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  height: 36px;
  padding: 0 0.85rem;
  border: 1px solid #e4e2ea;
  border-radius: 8px;
  background: #fff;
  color: #514c63;
  font-size: 0.88rem;
  font-weight: 600;
  white-space: nowrap;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;

  i {
    font-size: 0.85rem;
    color: #837f95;
  }

  &:hover:not(:disabled) {
    background: #faf9fc;
    border-color: #d5d1de;
    color: #2b2640;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
}

// Seletor de contexto — substitui o banner "Trocar para Administrador do
// Sistema" que ocupava uma faixa inteira acima da busca.
.trocar-conta-btn-contexto {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  height: 36px;
  padding: 0 0.85rem 0 0.3rem;
  border: 1px solid #e4e2ea;
  border-radius: 8px;
  background: #fff;
  color: #514c63;
  font-size: 0.88rem;
  font-weight: 600;
  white-space: nowrap;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;

  &__avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 27px;
    height: 27px;
    border-radius: 50%;
    flex: 0 0 auto;
    background: linear-gradient(135deg, #ede8f7 0%, #d9cdf0 100%);
    font-size: 0.85rem;

    // #43207a precisa ser forçado no <i>: o Font Awesome pode trazer cor
    // própria (ex.: .fa-user-shield tem color definido em alguns temas) e
    // color no span pai não vence a especificidade da classe do ícone.
    i {
      color: #43207a;
    }
  }

  &:hover {
    background: #faf9fc;
    border-color: #d9cdf0;
    color: $trocar-conta-purple;

    .trocar-conta-btn-contexto__avatar {
      animation: trocarContaContextoPulso 1.1s ease-in-out infinite;
    }
  }
}

// Pulso sutil no avatar do botão de contexto (WEL-5152/5157), só durante o
// hover — reforça o tom lúdico dos textos/ícones sorteados
// (SUPER_ADMIN_TRIGGERS) sem chamar atenção o tempo todo. Desliga para quem
// pediu menos movimento no SO.
@keyframes trocarContaContextoPulso {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(124, 58, 237, 0.35);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(124, 58, 237, 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .trocar-conta-btn-contexto:hover .trocar-conta-btn-contexto__avatar {
    animation: none;
  }
}

.trocar-conta-modal-body {
  padding: 1.15rem 1.5rem 1.5rem;
}

// Linha de busca + botão "Limpar filtros" (WEL-5152): flex row, mesmo gap
// dos botões do cabeçalho.
.trocar-conta-busca-linha {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 1rem;
}

// Ícone de lupa desenhado em ::before do wrapper (o input é um
// <b-form-input>, não aceita filho) — recuo à esquerda no próprio input.
.trocar-conta-busca-wrap {
  position: relative;
  flex: 1;

  &::before {
    content: "\f002"; // fa-search
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    font-size: 0.85rem;
    color: #b6b2c2;
    pointer-events: none;
    z-index: 1;
  }
}

.trocar-conta-busca {
  height: 44px;
  padding: 0.65rem 2.5rem 0.65rem 2.5rem;
  border-radius: 10px;
  border: 1px solid #e2e0ea;
  background: #fcfcfd;
  font-size: 0.9rem;

  &::placeholder {
    color: #b6b2c2;
  }

  &:focus {
    background: #fff;
    border-color: $trocar-conta-purple;
    box-shadow: 0 0 0 0.1rem rgba(71, 34, 130, 0.15);
  }
}

.trocar-conta-busca__limpar {
  position: absolute;
  top: 50%;
  right: 0.6rem;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #9a95a8;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    background: #efeef4;
    color: $trocar-conta-purple;
  }
}

// Botão "Limpar filtros" na linha de busca — mesmo estilo do "Limpar" das
// acessadas recentes. Fica sempre presente (com visibility em vez de v-if)
// para não deslocar o layout quando aparece/desaparece.
.trocar-conta-busca__limpar-filtros {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.5rem;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #837f95;
  font-size: 0.79rem;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.15s ease, visibility 0.15s ease;

  i {
    font-size: 0.8rem;
  }

  &:hover {
    color: $trocar-conta-purple;
  }
}

// WEL-5152: cada fileira de filtros é um wrapper flex que centraliza seus
// grupos. A primeira fileira tem Status + Categoria + Atividade; a segunda
// tem Tier + Maturidade. Assim nenhum grupo "cola" no fim de outra fileira
// e o layout fica organizado mesmo com linhas de larguras diferentes.
.trocar-conta-chips {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.45rem;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #f2f1f6;
}

.trocar-conta-chips__fileira {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
}

// Cada grupo de chips mutuamente exclusivos (status; atividade) é
// apresentado como um único button-group de cantos arredondados — só as
// pontas do grupo ficam arredondadas, os botões internos ficam colados
// (borda compartilhada), como um segmented control.
.trocar-conta-chip-group {
  display: inline-flex;
  border: 1px solid #e2e0ea;
  border-radius: 999px;
  overflow: hidden;

  .trocar-conta-chip {
    border-radius: 0;
    border: none;
    border-right: 1px solid #e2e0ea;

    &:last-child {
      border-right: none;
    }
  }
}

.trocar-conta-chip {
  padding: 0.4rem 0.9rem;
  border-radius: 999px;
  border: 1px solid #e2e0ea;
  background: #fff;
  color: #6a6579;
  font-size: 0.88rem;
  font-weight: 600;
  transition: background-color 0.15s ease, color 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    border-color: $trocar-conta-purple;
    color: $trocar-conta-purple;
  }

  &--ativo {
    background: $trocar-conta-purple;
    border-color: $trocar-conta-purple;
    color: #fff;

    // .trocar-conta-chip:hover isolado tem a mesma especificidade de
    // .trocar-conta-chip--ativo; sem este seletor mais específico, passar o
    // mouse num chip já ativo reescrevia o texto para roxo escuro sobre o
    // próprio fundo roxo (baixo contraste).
    &:hover {
      background: #3a1b6b;
      border-color: #3a1b6b;
      color: #fff;
    }
  }
}

// Ícone dentro do chip: mesmo tamanho dos ícones de indicador no card (não
// o tamanho do texto do chip, que ficava desproporcional). Cor só é
// forçada quando o filtro já tem uma cor semântica equivalente em outro
// lugar da tela (ex.: Ativas usa o mesmo verde do dot de status).
.trocar-conta-chip-icone {
  font-size: 0.78rem;
  margin-right: 0.3rem;

  &--ativa {
    color: #0e8058;
  }

  &--inativa {
    color: #b42335;
  }

  &--principal {
    color: #8950fc;
  }

  &--atencao {
    color: #b42335;
  }

  // Segundo estado do chip Atenção (WEL-5152): pendências de cadastro,
  // mesma cor da faixa âmbar do card.
  &--atencao-leve {
    color: #d97706;
  }

  // Terceiro estado: pendências administrativas (WEL-5157).
  &--pendencia {
    color: #2563eb;
  }

  &--muito-ativa {
    color: #ff7f00;
  }

  &--reducao {
    color: #e6b800;
  }

  &--quase-parada {
    color: #5bc0de;
  }

  // Grupo 4 — Tier (WEL-5149): mesma paleta ouro/prata/bronze do ícone no
  // card (.trocar-conta-tier-icone), pra funcionar como legenda de verdade.
  &--t1 {
    color: #d4af37;
  }

  &--t2 {
    color: #a8a9ad;
  }

  &--t3 {
    color: #cd7f32;
  }

  // Grupo 5 — Maturidade: mesma paleta do ícone no card
  // (.trocar-conta-maturidade-icone), pra funcionar como legenda de verdade.
  &--m1 {
    color: #8b5a2b;
  }

  &--m2 {
    color: #7cb342;
  }

  &--m3 {
    color: #4c9a4c;
  }

  &--m4 {
    color: #198754;
  }
}

.trocar-conta-chip--ativo .trocar-conta-chip-icone {
  color: #fff;
}

// Marcador de fim da lista renderizada — sem altura perceptível, só existe
// para o IntersectionObserver ter um alvo estável (ver iniciarObservadorLista).
.trocar-conta-lista-sentinela {
  height: 1px;
}

.trocar-conta-recentes {
  margin-bottom: 1.25rem;
}

.trocar-conta-recentes__cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  color: #2b2640;
  font-size: 0.9rem;
  margin-bottom: 0.6rem;
}

.trocar-conta-recentes__limpar {
  border: 0;
  background: none;
  color: #837f95;
  font-size: 0.76rem;
  font-weight: 600;

  &:hover {
    color: $trocar-conta-purple;
    text-decoration: underline;
  }
}

.trocar-conta-recentes__lista {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}

.trocar-conta-recente-card {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.75rem 0.4rem 0.4rem;
  border: 1px solid #eeecf3;
  border-radius: 999px;
  background: #fff;
  text-align: left;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #f7f4fc;
    border-color: $trocar-conta-purple;
  }

  &__textos {
    display: flex;
    flex-direction: column;
    min-width: 0;
    line-height: 1.2;
  }

  &__nome {
    font-size: 0.78rem;
    font-weight: 700;
    color: #2b2640;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 160px;
  }

  &__login {
    font-size: 0.7rem;
    color: #837f95;
  }
}

.trocar-conta-secao-titulo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  color: #2b2640;
  margin: 1.25rem 0 0.6rem;
  font-size: 0.9rem;

  &:first-child {
    margin-top: 0;
  }
}

.trocar-conta-secao-contador {
  font-size: 0.78rem;
  font-weight: 600;
  color: #837f95;
  background: #f4f2f9;
  border-radius: 999px;
  padding: 0.15rem 0.6rem;
}

.trocar-conta-dot {
  font-size: 0.7rem;
  margin-right: 0.35rem;

  &--ativa {
    color: #0e8058;
  }

  &--inativa {
    color: #b42335;
  }

  &--bloqueada {
    color: #946200;
  }

  &--suspensa {
    color: #7e8299;
  }
}

// Indicador de Atividade (só super-admin, só contas principais — ver
// atividadeInfo). Cores semânticas: laranja de marca para muito ativa,
// azul escuro para normal, amarelo para redução, azul claro para quase
// parada.
.trocar-conta-atividade-icone {
  font-size: 0.9rem;

  &--muito-ativa {
    color: #ff7f00;
  }

  &--normal {
    color: #0b4c8c;
  }

  &--reducao {
    color: #e6b800;
  }

  &--quase-parada {
    color: #5bc0de;
  }
}

// Indicador de Fase (só super-admin, só contas principais — ver faseInfo).
// Cor única (não há variação por fase, só o texto do tooltip muda).
.trocar-conta-fase-icone {
  color: #8950fc;
  font-size: 0.9rem;
}

// Indicador de Tier do cliente (WEL-5146). Só super-admin vê as estrelas;
// gradiente de medalha: ouro (tier 1, sólida), prata (tier 2, meia estrela),
// bronze (tier 3, contorno) — cor E preenchimento do ícone caem junto do
// nível, não só a cor.
.trocar-conta-tier-icone {
  font-size: 0.9rem;

  &--t1 {
    color: #d4af37;
  }

  &--t2 {
    color: #a8a9ad;
  }

  &--t3 {
    color: #cd7f32;
  }
}

// Indicador de Maturidade (WEL-5147). Cores por nível: verde escuro para
// Tree (consolidado), verde médio para Sapling, laranja para Sprout, cinza
// para Seedling (início da jornada).
.trocar-conta-maturidade-icone {
  font-size: 0.9rem;

  &--m1 {
    color: #8b5a2b;
  }

  &--m2 {
    color: #7cb342;
  }

  &--m3 {
    color: #4c9a4c;
  }

  &--m4 {
    color: #198754;
  }
}

// Indicador de Atenção (WEL-5148): consolida saldo em risco, sem envio
// recente, campanha falhando, CRM parado e implantação travada.
.trocar-conta-atencao-icone {
  color: #b42335;
  font-size: 0.9rem;
}

.trocar-conta-card {
  position: relative;
  border: 1px solid #ded9ee5e;
  border-radius: 12px;
  background: #fff;
  margin-bottom: 0.5rem;

  // Faixa de criticidade (WEL-5152): pseudo-elemento sobreposto à borda
  // esquerda, com z-index acima dos filhos — .trocar-conta-card__info e
  // __acoes têm fundo branco próprio e cobririam um box-shadow inset.
  // Também evita overflow:hidden, que cortava os dropdowns do Conexa e do
  // menu "⋮".
  // A largura do pseudo-elemento acompanha o raio (13px) para que a curva
  // seja desenhada corretamente; o gradiente pinta só os 4px da faixa e
  // deixa o resto transparente. Com largura menor que o raio, o navegador
  // comprime o arredondamento e a faixa sai deformada.
  &::before {
    content: "";
    position: absolute;
    left: -1px;
    top: -1px;
    bottom: -1px;
    width: 13px;
    border-radius: 12px 0 0 12px;
    background: linear-gradient(
      to right,
      var(--faixa-cor, transparent) 0,
      var(--faixa-cor, transparent) 4px,
      transparent 4px
    );
    z-index: 2;
    pointer-events: none;
  }

  // Vermelho: exige ação agora. Âmbar: acompanhar. Azul: cadastro.
  &--critico {
    --faixa-cor: #b42335;
  }

  &--alerta {
    --faixa-cor: #d97706;
  }

  &--pendencia {
    --faixa-cor: #2563eb;
  }
}

// Os filhos com fundo próprio precisam repetir o arredondamento do card,
// senão o branco deles "come" os cantos (o card não pode usar
// overflow:hidden por causa dos dropdowns).
.trocar-conta-card__principal > .trocar-conta-card__info {
  border-radius: 11px 0 0 11px;
}

.trocar-conta-card__principal > .trocar-conta-card__acoes {
  border-radius: 0 11px 11px 0;
}

// Com as subcontas abertas, o bloco principal perde o arredondamento de
// baixo — quem fecha o card passa a ser a lista de subcontas.
.trocar-conta-card__principal:not(:last-child) {
  > .trocar-conta-card__info {
    border-radius: 11px 0 0 0;
  }

  > .trocar-conta-card__acoes {
    border-radius: 0 11px 0 0;
  }
}

.trocar-conta-card__principal {
  display: flex;
  align-items: center;
  // WEL-5157: altura uniforme — cards com 1 ou 2 linhas de tags
  // centralizam o conteúdo verticalmente na mesma altura. Quem tem
  // mais conteúdo pode crescer sem invadir as bordas (min-height,
  // não height fixo).
  min-height: 5.5rem;
}

// WEL-5152: virou um grid (avatar | identidade | indicadores | saldo) em vez
// de flex — indicadores e saldo passam a ocupar colunas fixas, alinhadas
// entre todos os cards da lista, em vez de empilhar embaixo do nome.
// As colunas 3 e 4 são fixas: com `auto` elas cresciam conforme o conteúdo
// e invadiam a coluna de ações.
.trocar-conta-card__info {
  // A coluna de identidade é 1fr (encolhe): nomes longos raramente agregam
  // informação, enquanto os indicadores centrais precisam de respiro.
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) 270px 218px;
  align-items: center;
  column-gap: 0.85rem;
  flex: 1 1 auto;
  min-width: 0;
  // WEL-5157: subiu de 0.85rem — a linha 2 (login/código/documento) pode
  // quebrar em 2 linhas (flex-wrap) quando não cabe tudo lado a lado; o
  // grid já cresce sozinho pra acomodar, mas com 0.85rem o card 2-linhas
  // ficava visualmente apertado, quase colado nos vizinhos.
  padding: 1.05rem 0.5rem 1.05rem 1rem;
  text-align: left;
  background: #fff;
  transition: background-color 0.15s ease;

  &:hover,
  &.selecionado {
    background: #f7f4fc;
  }
}

// Conta atual: fica na lista como referência (agrupa as subcontas), mas não
// é clicável para troca. A cor de fundo (em vez de um badge "Conta atual")
// já indica que essa é a conta selecionada.
.trocar-conta-card__info--atual {
  cursor: default;
  background: #ece8f2;

  &:hover {
    background: #ece8f2;
  }
}

.trocar-conta-avatar {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  color: $trocar-conta-purple;
  background: linear-gradient(135deg, #ede8f7 0%, #d9cdf0 100%);
  border: 2px solid #e2d8f5;

  &--sm {
    width: 32px;
    height: 32px;
    font-size: 0.7rem;
  }
}

.trocar-conta-card__textos {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 0.25rem;
}

.trocar-conta-card__linha1 {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
}

// Identificadores (login, código, documento) numa linha só — nomes longos
// já são truncados na linha de cima, então aqui a prioridade é manter tudo
// visível sem quebrar.
.trocar-conta-card__linha2 {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  min-width: 0;
  flex-wrap: wrap;
}

// Uma linha só, com reticências: com flex-wrap o nome longo empurrava as
// tags para baixo e cada card ficava com uma altura diferente.
.trocar-conta-card__nome {
  font-weight: 700;
  font-size: 0.98rem;
  letter-spacing: -0.01em;
  color: #2b2640;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

// Badge "Atual" (WEL-5152): reforço visual de ehContaAtual, que antes só
// tingia o fundo do card (.trocar-conta-card__info--atual). O tingimento
// continua existindo — isto só deixa a informação legível sem precisar
// comparar a cor de fundo entre cards.
.trocar-conta-badge-atual {
  display: inline-flex;
  align-items: center;
  padding: 0.05rem 0.45rem;
  border-radius: 999px;
  background: #d9cdf0;
  color: $trocar-conta-purple;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  line-height: 1.5;
}

// Bloco único de indicadores (WEL-5152): Tier/Maturidade/Fase/Atividade/
// Atenção em 5 posições fixas, alinhadas entre cards. Cada posição mostra
// um traço quando o indicador não existe para a conta, em vez de sumir e
// desalinhar as próximas colunas (era o comportamento antigo).
// WEL-5152: grid de 5 colunas com largura fixa — cada célula ocupa sempre o
// mesmo espaço para que o bloco inteiro de indicadores fique no mesmo lugar
// em todos os cards, mesmo quando um indicador está ausente.
.trocar-conta-card__indicadores {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: center;
  justify-items: center;
  gap: 0.15rem;
  padding: 0 0.6rem;
  border-left: 1px solid #f2f1f6;
}

.trocar-conta-card__indicador {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  width: 100%;
  min-width: 0;
  line-height: 1;
}

// Cada <i> de indicador — forçar line-height e alinhamento para eliminar
// o vão que o Font Awesome deixa abaixo do glyph (o <i> é inline e herda
// line-height do body, que é maior que o tamanho do ícone).
.trocar-conta-tier-icone,
.trocar-conta-maturidade-icone,
.trocar-conta-fase-icone,
.trocar-conta-atividade-icone,
.trocar-conta-atencao-icone {
  line-height: 1;
  vertical-align: middle;
}

.trocar-conta-card__indicador-vazio {
  color: #cfd3da;
  font-size: 0.88rem;
  line-height: 1;
}

// Rótulo só aparece no hover do card (ver .trocar-conta-card:hover mais
// abaixo) — os ícones já têm tooltip individual; o rótulo é só uma legenda
// rápida pra não precisar parar em cada ícone.
.trocar-conta-card__indicador-rotulo {
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #8b8798;
  line-height: 1;
  text-align: center;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.trocar-conta-card:hover .trocar-conta-card__indicador-rotulo,
.trocar-conta-card:hover .trocar-conta-saldo__rotulo {
  opacity: 1;
}

.trocar-conta-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.8rem;
}

.trocar-conta-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.1rem 0.5rem;
  border-radius: 6px;
  background: #f2f1f6;
  color: #514c63;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;

  &--copiavel {
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;

    &:hover {
      background: #ece8f2;
      color: $trocar-conta-purple;
    }
  }

  &--link {
    text-decoration: none;
    transition: background-color 0.15s ease, color 0.15s ease;

    &:hover {
      background: #ece8f2;
      color: $trocar-conta-purple;
      text-decoration: none;
    }
  }

  // Tags secundárias (código, documento, subcontas) — menores para não
  // competirem com o @login, que é o identificador mais usado no dia a dia.
  &--sm {
    font-size: 0.7rem;
    padding: 0.08rem 0.4rem;
    line-height: 1.4;
  }
}

// WEL-5152: era empilhado embaixo do nome (margin-top), agora é a 4ª
// coluna do grid de .trocar-conta-card__info — largura fixa (width, não
// só min-width) para que a coluna não encolha quando uma conta não tem
// ícone de risco nem botão de recalcular.
// Ocupa toda a coluna do grid (sem width fixo): com largura própria menor
// que a coluna, o bloco ficava deslocado para a esquerda e sobrava um vão
// antes das ações.
.trocar-conta-saldo {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
  padding-left: 0.85rem;
  padding-right: 0.85rem;
  border-left: 1px solid #f2f1f6;
}

.trocar-conta-saldo__cabecalho {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.4rem;
}

// Rótulo — mesmo padrão de hover dos demais indicadores
// (.trocar-conta-card__indicador-rotulo): fica oculto até passar o mouse
// no card, pra não competir com o valor em si.
.trocar-conta-saldo__rotulo {
  font-size: 0.55rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #8b8798;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.trocar-conta-saldo__percentual {
  margin-left: auto;
  font-size: 0.79rem;
  font-weight: 700;
  color: $trocar-conta-purple;
  line-height: 1.2;

  &.trocar-conta-saldo--alerta {
    color: #d97706;
  }

  &.trocar-conta-saldo--critico {
    color: #b42335;
  }
}

.trocar-conta-saldo__barra {
  height: 6px;
  border-radius: 999px;
  background: #eeecf3;
  overflow: hidden;
}

// Cor por saudabilidade (WEL-5152): roxo é o padrão (folga confortável);
// os dois estados de alerta reaproveitam as cores já usadas no ícone de
// risco (#d97706) e no de atenção (#b42335) — ver saldoCorClasse().
// O preenchimento não arredonda a ponta direita: com o trilho já
// arredondado (overflow hidden), um raio no fim do preenchimento deixava
// uma "casquinha" do trilho aparecendo entre a curva e a borda quando a
// barra está quase cheia (ex.: 93%).
.trocar-conta-saldo__uso {
  display: block;
  height: 100%;
  border-radius: 999px 0 0 999px;
  background: linear-gradient(90deg, #8950fc 0%, #472282 100%);
  transition: width 0.3s ease, background 0.3s ease;

  &.trocar-conta-saldo--alerta {
    background: linear-gradient(90deg, #f0ad4e 0%, #d97706 100%);
  }

  &.trocar-conta-saldo--critico {
    background: linear-gradient(90deg, #e2536b 0%, #b42335 100%);
  }
}

.trocar-conta-saldo__texto {
  display: flex;
  align-items: baseline;
  gap: 0.25rem;
  font-size: 0.83rem;
  color: #2b2640;
  font-weight: 700;
  line-height: 1.3;
}

.trocar-conta-saldo__total {
  color: #a0a4b2;
  font-weight: 500;
}

// Ícone de risco no saldo — tamanho fixo (o Font Awesome traria o seu
// próprio, quebrando a proporção com o texto do saldo).
.trocar-conta-saldo__alerta {
  font-size: 0.7rem;
}

.trocar-conta-saldo__recalcular {
  border: 0;
  background: transparent;
  color: #b6b2c2;
  margin-left: 0.3rem;
  padding: 0;
  line-height: 1;
  vertical-align: baseline;

  // O tamanho precisa ser fixado no próprio <i>: as classes do Font Awesome
  // trazem font-size próprio e ignoram o herdado do botão (era o motivo de
  // ele voltar desproporcional a cada mudança global de fonte).
  i {
    font-size: 0.8rem;
    line-height: 1;
    vertical-align: baseline;
  }

  &:hover:not(:disabled) {
    color: $trocar-conta-purple;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
}

.trocar-conta-card__acoes {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 0 0 auto;
  padding-left: 0.75rem;
  padding-right: 0.4rem;
  border-left: 1px solid #f2f1f6;
  background: #fff;
}

// Cada ação ocupa um slot fixo — mesmo quando o botão/dropdown não está
// presente (v-if false), o span reserva o espaço para que os ícones fiquem
// alinhados entre todos os cards.
.trocar-conta-card__acao-slot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 32px;
  flex: 0 0 30px;
}

.trocar-conta-acao-btn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  min-height: 32px;
  border: 0;
  background: transparent;
  color: #837f95;
  text-decoration: none;

  // Ícones de ação (cubes, info, conexa, dots) — 1rem fixo, isolado do
  // font-size do botão (que o Font Awesome ignora de qualquer jeito). Cada
  // seletor é específico para não vazar para <i> de outras seções (ex.:
  // ícones de indicador ou de filtro).
  > .fas,
  > .far {
    font-size: 1rem;
  }

  &:hover:not(:disabled) {
    color: $trocar-conta-purple;
    text-decoration: none;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }

  &--sm {
    width: 30px;
    font-size: 0.85rem;
  }
}

// Também é âncora do badge com a contagem de subcontas (WEL-5152) — a
// informação saiu das tags da identidade e passou a viver no próprio botão
// que expande a lista, no mesmo padrão do contador de Recursos ativos.
.trocar-conta-card__toggle {
  position: relative;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  min-height: 32px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #837f95;

  i {
    font-size: 0.88rem;
  }

  &:hover {
    color: $trocar-conta-purple;
  }
}

.trocar-conta-menu {
  font-size: 0.85rem;

  .dropdown-item {
    padding: 0.5rem 1rem;

    &:active {
      background: $trocar-conta-purple;
    }
  }
}

// Botão de ação com contador (WEL-5150, Recursos ativos): âncora de
// posicionamento para o badge numérico no canto.
.trocar-conta-acao-btn--com-contador {
  position: relative;
}

// Ícone do dropdown Faturamento (Conexa) — laranja sólido, cor de marca
// do Conexa, para diferenciar das demais ações (cinza por padrão).
.trocar-conta-icone-conexa {
  color: #ff7a00;
}

// Bolinha de cobrança vencida (WEL-5150): mantém o ícone do Conexa
// laranja (cor da marca) e sobrepõe um ponto vermelho quando a conta tem
// cobrança vencida em aberto (motivo CONEXA_INADIMPLENTE).
.trocar-conta-acao-btn--com-alerta {
  position: relative;
}

.trocar-conta-badge-alerta {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #b42335;
  border: 1px solid #fff;
}

.trocar-conta-badge-contador {
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 14px;
  padding: 0 3px;
  border-radius: 999px;
  background: $trocar-conta-purple;
  color: #fff;
  font-size: 0.6rem;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
}

.trocar-conta-recursos-lista {
  max-height: 260px;
  overflow-y: auto;
  min-width: 200px;
}

.trocar-conta-recursos-lista__mensagem {
  padding: 0.5rem 1rem;
  color: #6a6579;
  font-size: 0.85rem;
}

.trocar-conta-recursos-lista__item {
  padding: 0.35rem 1rem;
  font-size: 0.85rem;
  color: #514c63;

  i {
    color: #a0a4b2;
  }
}

.trocar-conta-pop__linha {
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 0.15rem 0;

  span {
    color: #6a6579;
  }
}

.trocar-conta-card__subcontas {
  border-top: 1px solid #eeecf3;
  background: #fafafc;
  padding: 0.6rem 1rem 0.75rem 3.75rem;
}

.trocar-conta-card__subcontas-cabecalho {
  font-size: 0.78rem;
  font-weight: 700;
  color: #837f95;
  text-transform: uppercase;
  margin-bottom: 0.4rem;
}

.trocar-conta-subconta {
  display: flex;
  align-items: stretch;
  width: 100%;
  border-top: 1px solid #eeecf3;

  &:first-of-type {
    border-top: 0;
  }
}

.trocar-conta-subconta__info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex: 1 1 auto;
  min-width: 0;
  padding: 0.5rem 0.6rem;
  border-radius: 8px;
  background: transparent;
  text-align: left;

  &:hover,
  &.selecionado {
    background: #f0edf7;
  }
}

.trocar-conta-subconta__acoes {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  padding-right: 0.25rem;
}

.trocar-conta-subconta__textos {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}

.trocar-conta-subconta__nome {
  font-size: 0.86rem;
  font-weight: 600;
  color: #2b2640;
}

.trocar-conta-subconta__login {
  font-size: 0.78rem;
}

.trocar-conta-subconta__dados {
  font-size: 0.74rem;
}

.trocar-conta-ver-todas {
  display: inline-block;
  margin-top: 0.4rem;
  padding: 0.3rem 0;
  border: 0;
  background: none;
  color: $trocar-conta-purple;
  font-weight: 600;
  font-size: 0.82rem;

  &:hover {
    text-decoration: underline;
  }
}

.trocar-conta-icone-principal {
  color: #8950fc;
  font-size: 0.7rem;
}

// Ícone de conta pré-paga (money-bill-1) ao lado do nome da conta.
// Discreto (opacidade reduzida) para não competir com os demais ícones.
.trocar-conta-icone-pre {
  color: #6a6579;
  font-size: 0.7rem;
  margin-left: 0.3rem;
  opacity: 0.55;
}

// Ícone de enquadramento comercial (WEL-5157): mesmo espírito discreto do
// ícone de pré-paga — informação de cadastro, não indicador operacional.
.trocar-conta-icone-enquadramento {
  font-size: 0.7rem;
  margin-left: 0.3rem;
  opacity: 0.7;

  &--I {
    color: #6a6579;
  }

  &--P {
    color: #7c3aed;
  }

  &--R {
    color: #0b4c8c;
  }
}

// Dropdown de estágio do CRM (WEL-5157): chip que abre um menu com a lista
// completa de estágios — necessário porque com 14+ estágios o chip-group
// ocupava fileiras inteiras de botões enfileirados.
.trocar-conta-chip-dropdown {
  position: relative;
  // WEL-5157: .trocar-conta-chip-group tem overflow:hidden, que corta o
  // dropdown absolute. O visible aqui "fura" o clipping do container pai
  // (same trick dos dropdowns do Conexa no card — ver comentário linha
  // 4426).
  overflow: visible;

  .trocar-conta-chip-seta {
    margin-left: 0.3rem;
    font-size: 0.7rem;
    opacity: 0.6;
  }
}

.trocar-conta-chip-dropdown-items {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 50;
  min-width: 220px;
  max-height: 320px;
  overflow-y: auto;
  margin-top: 4px;
  padding: 0.35rem 0;
  background: #fff;
  border: 1px solid #ded9ee5e;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.trocar-conta-chip-dropdown-item {
  display: block;
  width: 100%;
  padding: 0.4rem 0.85rem;
  border: 0;
  background: transparent;
  color: #2b2640;
  font-size: 0.84rem;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: #f7f4fc;
  }

  &--ativo {
    background: #ede8f7;
    font-weight: 600;
  }

  &--limpar {
    border-top: 1px solid #f2f1f6;
    margin-top: 0.2rem;
    padding-top: 0.5rem;
    color: #837f95;
    font-size: 0.78rem;
  }
}

// Bootstrap renderiza tooltips no <body> com font-size padrão de 0.875rem —
// num modal com fontes entre 0.64rem e 0.9rem isso fica desproporcional.
// Reduzindo para acompanhar a escala do resto da Central de Contas.
.tooltip .tooltip-inner {
  font-size: 0.78rem;
}

// WEL-5184: cor do badge de campanhas
.trocar-conta-acao-btn--campanhas-critico .trocar-conta-badge-contador {
  background: #b42335;
}

.trocar-conta-acao-btn--campanhas-alerta .trocar-conta-badge-contador {
  background: #d97706;
}
</style>
